<template>
  <div
    v-if="localModel"
    class="input-materiales-wrapper"
  >
    <!-- ===== TABLA ÚNICA (no extrusion) ===== -->
    <template v-if="!IsProcesoExtrusion">
      <el-table
        :data="materialesArbol"
        :row-key="arbolRealesActivo ? '_key' : undefined"
        :tree-props="arbolRealesActivo ? { children: 'children' } : undefined"
        :default-expand-all="arbolRealesActivo"
        :row-class-name="claseFilaMaterial"
        style="width: 100%"
        max-height="300px"
        border
      >
        <el-table-column
          v-if="!isTintaCategory && !isBarnizCategory"
          prop="Material"
          :label="categoria.Descripcion"
          fixed
          v-bind="
            anchoColumna(
              'material',
              arbolRealesActivo ? ANCHOS_COLUMNA.materialConReales : ANCHOS_COLUMNA.material,
            )
          "
          class-name="col-material"
        >
          <template #default="{ row }">
            <!-- COTI-635: fila real — material simple, sin los campos del teórico -->
            <input-material
              v-if="row._tipo === 'Real'"
              v-model="row.Material"
              :categoria="categoria?.Codigo"
              :codigo-familia="CodigoFamiliaMaterial"
              :modulo="currentModule"
              :habilitado="materialesHabilitados"
              :filtrar-opciones="filtrarOpcionesMateriales"
              :precarga="materialesRaw"
              placeholder="Buscar material real..."
              @change="() => handleSeleccionarMaterialReal(row)"
              @materiales-cargados="alCargarMateriales"
            />
            <input-material
              v-else
              v-model="row.Material"
              :categoria="categoria?.Codigo"
              :codigo-familia="CodigoFamiliaMaterial"
              :modulo="currentModule"
              :habilitado="materialesHabilitados"
              :filtrar-opciones="filtrarOpcionesMateriales"
              :precarga="materialesRaw"
              placeholder="Seleccionar"
              @change="(val) => copyMaterialAttributes(val, row)"
              @materiales-cargados="alCargarMateriales"
            >
              <el-tag
                v-if="arbolRealesActivo"
                size="small"
                type="info"
              >
                Teórico
              </el-tag>
            </input-material>
          </template>
        </el-table-column>

        <!-- COTI-642: proceso del elemento del que proviene el material (opcional). -->
        <el-table-column
          v-if="mostrarColumnaProceso"
          label="Proceso"
          align="center"
          v-bind="anchoColumna('proceso', ANCHOS_COLUMNA.proceso)"
        >
          <template #default="{ row }">
            <el-select
              v-model="row.ProcesoOrigenUid"
              placeholder="—"
              size="small"
              clearable
              filterable
              class="ancho_total"
              @change="() => onProcesoOrigenChange(row)"
            >
              <el-option
                v-for="opt in opcionesProcesoOrigen"
                :key="opt._uid"
                :label="`${opt.ordenGlobal}. ${opt.descripcion}`"
                :value="opt._uid"
                :disabled="procesoOrigenIncompatibleConFila(opt, row)"
              >
                <el-tooltip
                  v-if="procesoOrigenIncompatibleConFila(opt, row)"
                  :content="motivoProcesoOrigenDeshabilitado(opt)"
                  placement="right"
                  :show-after="200"
                >
                  <span>{{ opt.ordenGlobal }}. {{ opt.descripcion }}</span>
                </el-tooltip>
                <span v-else>{{ opt.ordenGlobal }}. {{ opt.descripcion }}</span>
              </el-option>
            </el-select>
          </template>
        </el-table-column>

        <el-table-column
          v-if="showPorcentajeMaterial"
          prop="Porcentaje"
          label="Porcentaje (%)"
          align="center"
          v-bind="anchoColumna('porcentaje', ANCHOS_COLUMNA.porcentaje)"
        >
          <template #default="{ row }">
            <span
              v-if="row._tipo === 'Real'"
              class="valor-solo-lectura"
            >
              {{ row.Porcentaje != null ? Number(row.Porcentaje).toFixed(2) : '—' }}
            </span>
            <el-input-number
              v-else
              ref="inputRef"
              v-model="row.Porcentaje"
              :min="0"
              :max="100"
              :step="0.01"
              :precision="2"
              :controls="false"
              :formatter="formatter"
              :parser="parser"
              :class="{ 'error-porcentaje': !porcentajeValido }"
              @focus="handleFocus"
              @blur="handleBlur(row.Porcentaje)"
              @change="emitChanges"
            />
          </template>
        </el-table-column>

        <el-table-column
          v-for="col in dynamicColumns"
          :key="col.prop"
          :prop="col.prop"
          :label="col.label"
          align="center"
          v-bind="anchoColumna(col.prop, col.minWidth || ANCHOS_COLUMNA.atributoPorDefecto)"
          class-name="num-col"
        >
          <template #default="{ row }">
            <!-- COTI-635: en Tinta/Barniz el "Material" viaja como columna dinámica
                 (col.prop === 'Material'); a un real le damos selector propio ahí y
                 "—" en el resto de las columnas específicas de tinta (que no aplican). -->
            <input-material
              v-if="row._tipo === 'Real' && col.prop === 'Material'"
              v-model="row.Material"
              :categoria="categoria?.Codigo"
              :codigo-familia="CodigoFamiliaMaterial"
              :modulo="currentModule"
              :habilitado="materialesHabilitados"
              :filtrar-opciones="filtrarOpcionesMateriales"
              :precarga="materialesRaw"
              :mostrar-abrir="false"
              placeholder="Buscar material real..."
              size="small"
              style="width: 100%"
              @change="emitChanges"
              @materiales-cargados="alCargarMateriales"
            />
            <!-- COTI-635 (8.11): fila real, columnas dinámicas fuera de "Material" — sólo
                 lectura (grisado). Los atributos del material se leen de SU PROPIO material
                 (`textoAtributoMaterialReal`); el resto son columnas de proceso que no aplican
                 a un real y se resuelven según el tipo para no mostrar el código crudo. -->
            <template v-else-if="row._tipo === 'Real'">
              <span
                v-if="col.esAtributoDeMaterial"
                class="valor-solo-lectura"
              >
                {{ textoAtributoMaterialReal(row, col) }}
              </span>
              <span
                v-else-if="col.type === 'cuerpo_impresor_select'"
                class="valor-solo-lectura"
              >
                {{ row[col.prop] || '—' }}
              </span>
              <span
                v-else-if="col.type === 'color_picker'"
                class="valor-solo-lectura"
              >
                <span
                  v-if="row.Color?.Hex"
                  class="color-solo-lectura-swatch"
                  :style="{ backgroundColor: row.Color.Hex }"
                />
                {{ row.Color?.Descripcion ?? row[col.modelKey] ?? '—' }}
              </span>
              <span
                v-else-if="col.type === 'side_select'"
                class="valor-solo-lectura"
              >
                {{ ladoAplicacionOptions.find((opt) => opt.value === row[col.prop])?.label ?? '—' }}
              </span>
              <span
                v-else-if="col.type === 'tinta_type_select'"
                class="valor-solo-lectura"
              >
                {{
                  tipoTintaList.find((item) => item.Codigo === row[col.modelKey])?.Descripcion ??
                  '—'
                }}
              </span>
              <span
                v-else-if="col.type === 'remote_select'"
                class="valor-solo-lectura"
              >
                {{
                  getRemoteOptions(col.prop).find((item) => item.Codigo === row[col.prop])
                    ?.DescripcionInterna ??
                  row[col.prop] ??
                  '—'
                }}
              </span>
              <span
                v-else-if="col.type === 'select'"
                class="valor-solo-lectura"
              >
                {{
                  col.opciones?.find((opt) => opt.Clave === row[col.prop])?.Etiqueta ??
                  row[col.prop] ??
                  '—'
                }}
              </span>
              <span
                v-else-if="col.type === 'number'"
                class="valor-solo-lectura"
              >
                {{ row[col.modelKey] ?? '—' }}
              </span>
              <!-- 'text', 'switch', 'date' y cualquier otro tipo sin rama propia: misma
                   representación de respaldo que usa el teórico editable (el-input por
                   defecto, ver v-else más abajo), aquí en sólo lectura. -->
              <span
                v-else
                class="valor-solo-lectura"
              >
                {{ row[col.prop] ?? '—' }}
              </span>
            </template>
            <template v-else>
              <el-select
                v-if="col.type === 'cuerpo_impresor_select'"
                v-model="row[col.prop]"
                placeholder="Cuerpo"
                size="small"
                style="width: 100%"
                :disabled="col.isDynamic && !col.editable"
                @change="emitChanges"
              >
                <el-option
                  v-for="opt in opcionesCuerpoImpresorFila(row[col.prop])"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value"
                />
              </el-select>
              <ColorSelect
                v-else-if="col.type === 'color_picker'"
                v-model="row[col.modelKey]"
                :preload="row.Color || null"
                :settings="{
                  label: col.label,
                  hideLabel: true,
                  teleported: true,
                  size: 'small',
                  disabled: col.isDynamic && !col.editable,
                  placeholder: 'Buscar Color',
                }"
                @select-object="
                  (obj) => {
                    row.Color = obj || null;
                    invalidateColorCache(row);
                    emitChanges();
                  }
                "
                @change="
                  (code) => {
                    row.CodigoColor = code ?? null;
                    invalidateColorCache(row);
                    emitChanges();
                  }
                "
              />
              <el-autocomplete
                v-else-if="col.type === 'tinta_autocomplete'"
                v-model="row.MaterialDesc"
                size="small"
                :value-key="'DescripcionInterna'"
                :fetch-suggestions="makeTintaSuggest(row)"
                clearable
                :placeholder="materialInputPlaceholder"
                style="width: 100%"
                @select="(item) => handleSeleccionarTintaMaterial(row, item)"
              />
              <el-select
                v-else-if="col.type === 'side_select'"
                v-model="row[col.prop]"
                placeholder="Lado"
                size="small"
                style="width: 100%"
                :disabled="col.isDynamic && !col.editable"
                @change="emitChanges"
              >
                <el-option
                  v-for="opt in ladoAplicacionOptions"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value"
                />
              </el-select>

              <el-select
                v-else-if="col.type === 'tinta_type_select'"
                v-model="row[col.modelKey]"
                placeholder="Tipo"
                size="small"
                style="width: 100%"
                :disabled="col.isDynamic && !col.editable"
                @change="emitChanges"
              >
                <el-option
                  v-for="item in tipoTintaList"
                  :key="item.Codigo"
                  :label="item.Descripcion"
                  :value="item.Codigo"
                />
              </el-select>

              <el-select
                v-else-if="col.type === 'remote_select'"
                v-model="row[col.prop]"
                filterable
                remote
                clearable
                placeholder="Buscar..."
                :remote-method="(q) => handleRemoteSearch(q, col.prop)"
                :loading="loadingSearch[col.prop]"
                size="small"
                style="width: 100%"
                @focus="handleRemoteSearch('', col.prop)"
              >
                <el-option
                  v-for="item in getRemoteOptions(col.prop)"
                  :key="item.Codigo"
                  :label="item.DescripcionInterna"
                  :value="item.Codigo"
                />
              </el-select>

              <el-select
                v-else-if="col.type === 'select'"
                v-model="row[col.prop]"
                :multiple="col.multiple"
                filterable
                clearable
                placeholder="Seleccionar"
                size="small"
                style="width: 100%"
                :disabled="col.isDynamic && !col.editable"
                @change="emitChanges"
              >
                <el-option
                  v-for="opt in col.opciones"
                  :key="opt.Codigo ?? opt.Clave"
                  :label="opt.Etiqueta ?? opt.Clave"
                  :value="opt.Clave"
                />
              </el-select>

              <el-input-number
                v-else-if="col.type === 'number'"
                v-model="row[col.modelKey]"
                :min="0"
                :step="col.step ?? 1"
                :precision="col.precision ?? 0"
                :controls="false"
                :disabled="col.isDynamic && !col.editable"
                :formatter="
                  (val) => tableLocale.formatter(val, col.precision, row.Codigo ?? $index)
                "
                :parser="tableLocale.parser"
                @focus="(e) => tableLocale.handleFocus(e, row.Codigo ?? $index)"
                @blur="
                  (e) =>
                    tableLocale.handleBlur(e, row[col.prop], col.precision, row.Codigo ?? $index)
                "
                @dblclick="col.prop === 'Ancho' ? handleDblClickAncho(row) : null"
                @change="(val) => onNumberChange(row, col, val)"
              />

              <el-input
                v-else
                v-model="row[col.prop]"
                :placeholder="col.label"
                clearable
                :disabled="col.isDynamic && !col.editable"
                @input="emitChanges"
              />
            </template>
          </template>
        </el-table-column>

        <!-- COTI-635: necesidad calculada / planificado / diferencia, y cantidad real editable -->
        <el-table-column
          v-if="mostrarCantidadReales"
          label="Cantidad"
          align="center"
          v-bind="anchoColumna('cantidad', ANCHOS_COLUMNA.cantidad)"
        >
          <template #default="{ row }">
            <template v-if="row._tipo === 'Real'">
              <!-- COTI-635: la cantidad real se carga en la unidad con la que se muestra la
                   necesidad del teórico (en OT, la del recurso o su respaldo; en ET, la efectiva
                   del material) — el sufijo con la abreviatura le muestra al usuario en qué
                   unidad está tipeando. -->
              <div class="cantidad-real-input">
                <el-input-number
                  v-model="row.Cantidad"
                  :min="0"
                  :step="10"
                  :precision="3"
                  size="small"
                  controls-position="right"
                  :style="{ width: `${ANCHOS_COLUMNA.inputCantidadReal}px` }"
                  @change="emitChanges"
                />
                <span
                  v-if="abreviaturaRealMostrada(row)"
                  class="unidad-sufijo"
                >
                  {{ abreviaturaRealMostrada(row) }}
                </span>
                <el-tooltip
                  v-if="avisoRealEnOtraUnidad(row)"
                  :content="avisoRealEnOtraUnidad(row)"
                  placement="top"
                >
                  <el-icon class="aviso-otra-unidad"><IconAlert /></el-icon>
                </el-tooltip>
              </div>
            </template>
            <template v-else>
              <!-- COTI-635: necesidad / real / diferencia en UNA sola unidad (la del recurso del
                   proceso, o la propia del material como respaldo), tomadas del helper. La
                   columna sólo existe en OT: en ET `mostrarCantidadReales` es false. -->
              <div>
                Necesidad:
                <strong>{{ textoNecesidadOT(row) }}</strong>
                <el-tooltip
                  v-if="mensajeOrigenOT(row)"
                  :content="mensajeOrigenOT(row)"
                  placement="top"
                >
                  <el-icon class="aviso-otra-unidad"><IconInfo /></el-icon>
                </el-tooltip>
                <el-tooltip
                  v-if="mostrarPendienteRecalculo(row)"
                  content="Cambió el recurso: la necesidad corresponde al último guardado. Guarde la orden para recalcularla."
                  placement="top"
                >
                  <el-tag
                    size="small"
                    type="warning"
                  >
                    Pendiente de recálculo
                  </el-tag>
                </el-tooltip>
              </div>
              <div>
                Real: {{ textoRealOT(row) }}
                <span
                  v-if="resumenOT(row).realesEnOtraUnidad.length"
                  class="unidad-sufijo"
                >
                  ({{ resumenOT(row).realesEnOtraUnidad.length }} en otra unidad)
                </span>
              </div>
              <el-tag
                size="small"
                :type="tipoTagDiferencia(row)"
              >
                Diferencia: {{ textoDiferenciaOT(row) }}
              </el-tag>
            </template>
          </template>
        </el-table-column>

        <el-table-column
          label="Acción"
          fixed="right"
          v-bind="
            anchoColumna(
              'accion',
              arbolRealesActivo ? ANCHOS_COLUMNA.accionConReales : ANCHOS_COLUMNA.accion,
            )
          "
        >
          <template #default="{ row }">
            <template v-if="row._tipo === 'Real'">
              <el-tooltip
                content="Reservar cantidad"
                placement="top"
              >
                <el-button
                  type="primary"
                  size="small"
                  plain
                  :icon="IconLock"
                  @click="reservarCantidad(row)"
                />
              </el-tooltip>
              <el-button
                type="danger"
                size="small"
                :icon="IconDelete"
                @click="quitarMaterialReal(row)"
              />
            </template>
            <template v-else>
              <el-tooltip
                v-if="arbolRealesActivo"
                content="Agregar material real"
                placement="top"
              >
                <el-button
                  type="primary"
                  size="small"
                  plain
                  :icon="IconPlus"
                  @click="agregarMaterialReal(row)"
                />
              </el-tooltip>
              <el-button
                type="danger"
                size="small"
                :icon="IconDelete"
                @click="onDeleteRowByRef(row)"
              />
            </template>
          </template>
        </el-table-column>
      </el-table>

      <div
        v-if="porcentajeExcedido"
        class="error-message"
        style="color: #f56c6c; font-size: 14px"
      >
        ⚠️ La suma de porcentajes supera el 100% (actual:
        {{ formatNumberLocale(totalPorcentaje, 2) }}%)
      </div>
      <div
        v-else-if="porcentajeIncompleto"
        class="error-message"
        style="color: #f56c6c; font-size: 14px"
      >
        ⚠️ La suma de porcentajes es menor a 100% (actual:
        {{ formatNumberLocale(totalPorcentaje, 2) }}%)
      </div>

      <div
        class="flex items-center justify-between"
        style="margin-top: 5px; margin-bottom: 20px"
      >
        <div
          v-if="showTotalPolimeros"
          style="font-weight: 600"
        >
          {{ labelTotalPolimeros }}: {{ totalPolimeros }}
        </div>
        <div class="button-position">
          <el-button
            v-if="localModel.ElementoMateriales.length === 0 || isMultiMaterialEffective"
            type="primary"
            @click="onAddRow"
            >+1 Material</el-button
          >
        </div>
      </div>
    </template>

    <!-- ===== TABLAS POR TORNILLO (extrusion) ===== -->
    <template v-else>
      <div
        v-for="(n, index) in localModelTornillos"
        :key="index"
        class="tornillo-section"
      >
        <div
          class="tornillo-section-header"
          @click="toggleTornillo(index)"
        >
          <span
            class="tornillo-section-chevron"
            :class="{ 'is-collapsed': tornilloCollapseState[index] === false }"
            >▼</span
          >
          <span class="tornillo-section-title">Tornillo {{ index + 1 }}</span>
          <el-select
            v-model="n.CodigoMaterialMezcla"
            filterable
            clearable
            placeholder="Material mezcla..."
            :value-key="'Codigo'"
            class="tornillo-material-select"
            @click.stop
            @change="(val) => handleMaterialMezclaChange(index, val)"
          >
            <el-option
              v-for="opt in materialesMezclaConSeleccionados"
              :key="opt.Codigo"
              :label="opt.DescripcionInterna"
              :value="opt.Codigo"
            />
          </el-select>
          <span
            :class="[
              'tornillo-sum-badge',
              sumOkForTornillo(index + 1) ? 'tornillo-sum-ok' : 'tornillo-sum-error',
            ]"
          >
            Σ {{ formatNumberLocale(sumForTornillo(index + 1), 2) }}%
          </span>
        </div>

        <div v-show="tornilloCollapseState[index] !== false">
          <el-table
            :data="rowsByTornillo(index + 1)"
            :row-class-name="claseFilaMaterial"
            style="width: 100%"
            max-height="300px"
            border
          >
            <el-table-column
              v-if="!isTintaCategory"
              prop="Material"
              :label="categoria.Descripcion"
              fixed
              v-bind="anchoColumna('material', ANCHOS_COLUMNA.material)"
            >
              <template #default="{ row }">
                <input-material
                  v-model="row.Material"
                  :categoria="categoria?.Codigo"
                  :codigo-familia="CodigoFamiliaMaterial"
                  :modulo="currentModule"
                  :habilitado="materialesHabilitados"
                  :filtrar-opciones="filtrarOpcionesMateriales"
                  :precarga="materialesRaw"
                  :mostrar-abrir="false"
                  placeholder="Seleccionar"
                  @change="(val) => copyMaterialAttributes(val, row)"
                  @materiales-cargados="alCargarMateriales"
                />
              </template>
            </el-table-column>

            <!-- COTI-642: proceso del elemento del que proviene el material (opcional). -->
            <el-table-column
              v-if="mostrarColumnaProceso"
              label="Proceso"
              align="center"
              v-bind="anchoColumna('proceso', ANCHOS_COLUMNA.proceso)"
            >
              <template #default="{ row }">
                <el-select
                  v-model="row.ProcesoOrigenUid"
                  placeholder="—"
                  size="small"
                  clearable
                  filterable
                  class="ancho_total"
                  @change="() => onProcesoOrigenChange(row)"
                >
                  <el-option
                    v-for="opt in opcionesProcesoOrigen"
                    :key="opt._uid"
                    :label="`${opt.ordenGlobal}. ${opt.descripcion}`"
                    :value="opt._uid"
                    :disabled="procesoOrigenIncompatibleConFila(opt, row)"
                  >
                    <el-tooltip
                      v-if="procesoOrigenIncompatibleConFila(opt, row)"
                      :content="motivoProcesoOrigenDeshabilitado(opt)"
                      placement="right"
                      :show-after="200"
                    >
                      <span>{{ opt.ordenGlobal }}. {{ opt.descripcion }}</span>
                    </el-tooltip>
                    <span v-else>{{ opt.ordenGlobal }}. {{ opt.descripcion }}</span>
                  </el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column
              v-if="showPorcentajeMaterial"
              prop="Porcentaje"
              label="Porcentaje (%)"
              align="center"
              v-bind="anchoColumna('porcentaje', ANCHOS_COLUMNA.porcentaje)"
            >
              <template #default="{ row }">
                <el-input-number
                  ref="inputRef"
                  v-model="row.Porcentaje"
                  :min="0"
                  :max="100"
                  :step="0.01"
                  :precision="2"
                  :controls="false"
                  :formatter="formatter"
                  :parser="parser"
                  :class="{ 'error-porcentaje': !porcentajeValido }"
                  @focus="handleFocus"
                  @blur="handleBlur(row.Porcentaje)"
                  @change="emitChanges"
                />
              </template>
            </el-table-column>

            <el-table-column
              v-for="col in dynamicColumns"
              :key="col.prop"
              :prop="col.prop"
              :label="col.label"
              align="center"
              v-bind="anchoColumna(col.prop, col.minWidth || ANCHOS_COLUMNA.atributoPorDefecto)"
              class-name="num-col"
            >
              <template #default="{ row }">
                <el-select
                  v-if="col.type === 'cuerpo_impresor_select'"
                  v-model="row[col.prop]"
                  placeholder="Cuerpo"
                  size="small"
                  style="width: 100%"
                  :disabled="col.isDynamic && !col.editable"
                  @change="emitChanges"
                >
                  <el-option
                    v-for="opt in opcionesCuerpoImpresorFila(row[col.prop])"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                  />
                </el-select>
                <ColorSelect
                  v-else-if="col.type === 'color_picker'"
                  v-model="row[col.modelKey]"
                  :preload="row.Color || null"
                  :settings="{
                    label: col.label,
                    hideLabel: true,
                    teleported: true,
                    size: 'small',
                    disabled: col.isDynamic && !col.editable,
                    placeholder: 'Buscar Color',
                  }"
                  @select-object="
                    (obj) => {
                      row.Color = obj || null;
                      invalidateColorCache(row);
                      emitChanges();
                    }
                  "
                  @change="
                    (code) => {
                      row.CodigoColor = code ?? null;
                      invalidateColorCache(row);
                      emitChanges();
                    }
                  "
                />
                <el-autocomplete
                  v-else-if="col.type === 'tinta_autocomplete'"
                  v-model="row.MaterialDesc"
                  size="small"
                  :value-key="'DescripcionInterna'"
                  :fetch-suggestions="makeTintaSuggest(row)"
                  clearable
                  placeholder="Ingresar color/tinta"
                  style="width: 100%"
                  @select="(item) => handleSeleccionarTintaMaterial(row, item)"
                />
                <el-select
                  v-else-if="col.type === 'side_select'"
                  v-model="row[col.prop]"
                  placeholder="Lado"
                  size="small"
                  style="width: 100%"
                  :disabled="col.isDynamic && !col.editable"
                  @change="emitChanges"
                >
                  <el-option
                    v-for="opt in ladoAplicacionOptions"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                  />
                </el-select>
                <el-select
                  v-else-if="col.type === 'tinta_type_select'"
                  v-model="row[col.modelKey]"
                  placeholder="Tipo"
                  size="small"
                  style="width: 100%"
                  :disabled="col.isDynamic && !col.editable"
                  @change="emitChanges"
                >
                  <el-option
                    v-for="item in tipoTintaList"
                    :key="item.Codigo"
                    :label="item.Descripcion"
                    :value="item.Codigo"
                  />
                </el-select>
                <el-select
                  v-else-if="col.type === 'remote_select'"
                  v-model="row[col.prop]"
                  filterable
                  remote
                  clearable
                  placeholder="Buscar..."
                  :remote-method="(q) => handleRemoteSearch(q, col.prop)"
                  :loading="loadingSearch[col.prop]"
                  size="small"
                  style="width: 100%"
                  @focus="handleRemoteSearch('', col.prop)"
                >
                  <el-option
                    v-for="item in getRemoteOptions(col.prop)"
                    :key="item.Codigo"
                    :label="item.DescripcionInterna"
                    :value="item.Codigo"
                  />
                </el-select>
                <el-input-number
                  v-else-if="col.type === 'number'"
                  v-model="row[col.modelKey]"
                  :min="0"
                  :step="col.step ?? 1"
                  :precision="col.precision ?? 0"
                  :controls="false"
                  :disabled="col.isDynamic && !col.editable"
                  :formatter="
                    (val) => tableLocale.formatter(val, col.precision, row.Codigo ?? $index)
                  "
                  :parser="tableLocale.parser"
                  @focus="(e) => tableLocale.handleFocus(e, row.Codigo ?? $index)"
                  @blur="
                    (e) =>
                      tableLocale.handleBlur(e, row[col.prop], col.precision, row.Codigo ?? $index)
                  "
                  @change="(val) => onNumberChange(row, col, val)"
                />
                <el-input
                  v-else
                  v-model="row[col.prop]"
                  :placeholder="col.label"
                  clearable
                  :disabled="col.isDynamic && !col.editable"
                />
              </template>
            </el-table-column>

            <el-table-column
              label="Acción"
              fixed="right"
              v-bind="anchoColumna('accion', ANCHOS_COLUMNA.accion)"
            >
              <template #default="{ row }">
                <el-button
                  type="danger"
                  size="small"
                  :icon="IconDelete"
                  @click="onDeleteRowByRef(row)"
                />
              </template>
            </el-table-column>
          </el-table>

          <div
            class="button-position"
            style="margin-top: 6px"
          >
            <el-button
              type="primary"
              @click="onAddRowForTornillo(index + 1)"
              >+1 Material</el-button
            >
          </div>
        </div>
        <!-- /.v-show collapse -->
      </div>
    </template>
  </div>
</template>

<script setup>
import {
  computed,
  onMounted,
  inject,
  ref,
  watch,
  nextTick,
  onBeforeMount,
} from 'vue';
import { useErrorRegistro } from '@/shared/composables/use_error_registry.js';
import { procesoOrigenIncompatibleConMaterial } from '@/shared/utils/procesos_precedentes';
import {
  abreviaturaUnidadReal,
  convertirPrincipalAUnidadReal,
  necesidadTeorica,
  redondearCantidadDual,
  resolverCodigoUnidadReal,
} from '@/shared/utils/material_unidades_conversion.js';
import {
  convertirRealAUnidad,
  mensajeOrigen,
  realEnOtraUnidad,
  resumenCantidades,
  semillaPrimerReal,
  textoCantidad,
  unidadActiva,
} from '@/shared/utils/necesidad_unidad_recurso.js';
import { storeToRefs } from 'pinia';
import MaterialService from '@/services/material_service';
import atributosDinamicosService from '@/services/atributos_dinamicos_service';
import IconDelete from '~icons/mdi/delete';
import IconLock from '~icons/mdi/lock';
import IconPlus from '~icons/mdi/plus';
import IconAlert from '~icons/mdi/alert-outline';
import IconInfo from '~icons/mdi/information-outline';

import { ElementoBase } from '@/enum/elemento_base';
import { Modules } from '@/enum/modules';
import ColorSelect from '@/shared/components/tintas/color_select.vue';
import CustomSelect from '@/shared/components/custom_select.vue';
import InputMaterial from '@/shared/components/input_material.vue';
import { useFormaStore } from '@/stores/forma/forma_store';
import { useTintaStore } from '@/stores/tinta_store.js';
import { UnidadMedida } from '@/enum/unidad_medida';
import {
  milimeterVisualTo,
  visualToMilimeter,
  isDimensionesProp,
} from '@/shared/composables/useUnitConversion';
import {
  useAplicaRegla,
  MODULOS_CON_MATERIAL,
} from '@/shared/composables/use_aplica_regla.js';
import { MaterialCategoria } from '@/enum/material_categoria_enum.js';
import { camposTintaPorDefecto } from '@/shared/utils/tipo_tinta_por_proceso.js';
import { LABELS_MATRIZ_IMPRESION_DEFAULT } from '@/shared/utils/label_matriz_impresion.js';
import { getCuerpoImpresorOptions } from '@/shared/composables/useCuerpoImpresor.js';
import { useConfiguracionStore } from '@/stores/configuracion-general.js';
import { useConfiguracionesPorDefectoStore } from '@/views/configuraciones_por_defecto/stores/configuraciones_por_defecto_store.js';

import { formatNumberLocale } from '@/shared/utils/locale_number_utils.js';
import { useLocaleNumberInput } from '@/shared/composables/useLocaleNumberInput.js';
import { useLocaleNumberInputForTable } from '@/shared/composables/useLocaleNumberInputForTable.js';

/**
 * Anchos de las columnas de la grilla de materiales, en píxeles y en un solo lugar.
 *
 * Antes estaban repartidos como literales en cada `el-table-column` del template (dos veces:
 * la grilla normal y la rama por tornillo de Extrusión) y en tres bloques `let minWidth = ...`
 * dentro de `dynamicColumns`. Centralizarlos es lo que permite ajustar el ancho de una columna
 * sin salir a cazar números por un archivo de ~2900 líneas.
 *
 * Distinción importante: `material` y `accion` se aplican como `width` (ancho EXACTO, la
 * columna no se mueve), el resto como `min-width` (PISO, `el-table` las ensancha si sobra
 * espacio). Por eso achicar un `min-width` no garantiza una columna más angosta si la tabla
 * tiene lugar de sobra — lo que sí hace es dejar de robarle ancho a las demás.
 */
const ANCHOS_COLUMNA = Object.freeze({
  /**
   * Cuál es la ÚNICA columna elástica. `el-table` trae `fit` en `true`, así que estira las
   * columnas para que la grilla ocupe todo el contenedor; sólo respeta exacto el ancho de las
   * que declaran `width`. Las que declaran `min-width` se reparten el sobrante entre sí, que
   * es por qué los anchos "no se respetaban" aunque estuvieran definidos.
   *
   * La solución es la del ejemplo oficial de la doc: `width` en todas menos una, que absorbe
   * el resto. Acá esa única columna se elige por código con esta clave; su ancho pasa a ser
   * un piso (`min-width`) y el de todas las demás un ancho exacto (`width`).
   *
   * Valores posibles: 'material', 'proceso', 'porcentaje', 'cantidad', 'accion', o el `prop`
   * de una columna de atributo ('Ancho', 'Gramaje', …).
   */
  columnaElastica: 'material',

  /** Primera columna, la del material. Es la que más contenido tiene (nombre largo del
   * material, el tag "Teórico" y el botón de abrir el ABM), así que se lleva el ancho fijo
   * más grande. Con el árbol de reales activo necesita más aire todavía: la fila hija repite
   * selector y botón con la indentación del árbol encima. */
  material: 420,
  materialConReales: 520,

  /** Columna de acciones: un botón en la fila teórica, tres en la real. */
  accion: 60,
  accionConReales: 110,

  proceso: 200,
  porcentaje: 110,

  /** La columna "Cantidad" la dimensiona el renglón del teórico ("Necesidad: 11.28 Kg · 250
   * Hj"), que es texto largo — no el input de la fila real. Por eso el input tiene su propio
   * ancho: si usara el 100 % de la celda quedaría desproporcionadamente largo para un número
   * corto, sólo porque arriba hay una leyenda ancha. */
  cantidad: 250,
  inputCantidadReal: 130,

  /** Piso por atributo del material. Los numéricos cortos (medidas, gramaje) no necesitan los
   * 150 px que usaban antes; con eso le devuelven ancho a la primera columna. */
  atributos: Object.freeze({
    Ancho: 150,
    Alto: 150,
    Largo: 150,
    Gramaje: 150,
  }),
  atributoPorDefecto: 150,

  /** Columnas fijas de Tinta/Barniz: el piso lo marca el control que monta cada tipo, no el
   * valor que muestra. */
  porTipoDeControl: Object.freeze({
    color_picker: 160,
    remote_select: 180,
    tinta_autocomplete: 200,
  }),
  tipoDeControlPorDefecto: 120,
});

/**
 * Binding de ancho de una columna: `min-width` (piso, se estira) para la columna elástica y
 * `width` (exacto, no se mueve) para todas las demás. Se aplica con `v-bind` en el template
 * para no repetir el condicional en cada `el-table-column`.
 */
function anchoColumna(clave, ancho) {
  return clave === ANCHOS_COLUMNA.columnaElastica ? { 'min-width': ancho } : { width: ancho };
}

/** Piso de una columna fija de Tinta/Barniz, según el control que monta. */
function anchoPorTipoDeControl(type) {
  return ANCHOS_COLUMNA.porTipoDeControl[type] ?? ANCHOS_COLUMNA.tipoDeControlPorDefecto;
}

/** Piso de una columna de atributo del material (`Ancho`, `Gramaje`, dinámicos, …). */
function anchoDeAtributo(prop) {
  return ANCHOS_COLUMNA.atributos[prop] ?? ANCHOS_COLUMNA.atributoPorDefecto;
}

const { inputRef, formatter, parser, handleFocus, handleBlur } = useLocaleNumberInput(2);
const tableLocale = useLocaleNumberInputForTable();

const props = defineProps({
  modelValue: { type: Object, required: true },
  proceso: { type: Object, required: true },
  // COTI-502: Determinar label para polimero
  labelTotalPolimeros: {
    type: String,
    default: LABELS_MATRIZ_IMPRESION_DEFAULT.total,
  },
  validarPorcentaje: { type: Boolean, default: false },
  categoria: { type: Object, required: false },
  codigoElementoTipo: { type: Number, default: null },
  cantidadCapas: { type: Number, default: 1 },
  elementoProcesoTornillos: { type: Array, default: () => [] },
  CodigoFamiliaMaterial: { type: Number, required: false },
  // COTI-635: sólo ET y OT activan la grilla en árbol de materiales reales.
  mostrarMaterialesReales: { type: Boolean, default: false },
  // COTI-642: procesos del elemento (para la columna "Proceso") + `_uid` del proceso propio.
  procesosDelElemento: { type: Array, default: () => [] },
  procesoUid: { type: String, default: '' },
  // COTI-635: unidad de medida del recurso del proceso ({ Codigo, Abreviatura, Descripcion }) y
  // marca de que el recurso elegido difiere del último guardado. Sólo los usa la grilla de OT.
  unidadRecurso: { type: Object, default: null },
  recursoPendienteRecalculo: { type: Boolean, default: false },
  // Máximo de cuerpos impresores del recurso (CantidadCuerposImpresores); null/0 = todas las opciones.
  maxCuerposImpresores: { type: Number, default: null },
});

const opcionesCuerpoImpresor = computed(() => getCuerpoImpresorOptions(props.maxCuerposImpresores));

// Si la fila ya tiene un cuerpo mayor al máximo del recurso, se conserva para no perder el dato.
function opcionesCuerpoImpresorFila(valorActual) {
  const n = Number(valorActual);
  if (!Number.isFinite(n) || n <= 0 || opcionesCuerpoImpresor.value.some((o) => o.value === n)) {
    return opcionesCuerpoImpresor.value;
  }
  return [...opcionesCuerpoImpresor.value, { label: n, value: n }];
}

// INYECCIONES
const reportarErrorSumaMateriales = useErrorRegistro('sumaMaterialesTornillos');
const currentModule = inject('currentModule');
const currentElementoBase = inject('currentElementoBase');
const currentElemento = inject('currentElemento', ref(null));
const anchoMinimoMMInjected = inject('anchoMinimoMM', null);
const selectedMaterialAnchoMM = inject('selectedMaterialAnchoMM', null);
const unidadImposicion = inject(
  'unidadImposicion',
  computed(() => 'mm'),
);
// Provisto por *_edit.vue (Solicitud no lo provee — default {} vacío, se comporta como antes).
const materialesSeleccionadosPorCategoriaInject = inject(
  'materialesSeleccionadosPorCategoria',
  computed(() => ({})),
);

// STORES
const tintaStore = useTintaStore();
const { tipoTintaList } = storeToRefs(tintaStore);
const { searchTintaByColorHTTP, searchAniloxHTTP, searchCintaHTTP } = tintaStore;
const formaStore = useFormaStore();
const { formaList } = storeToRefs(formaStore);

// Configuracion
const configuracionStore = useConfiguracionStore();
const { firstConfiguraciones } = configuracionStore;
const configuracionesPorDefectoStore = useConfiguracionesPorDefectoStore();
const {
  coberturaTintaPorProceso,
  coberturaBarnizPorProceso,
  tipoTintaDefectoPorProceso,
  tintaDefectoPorProceso,
  barnizDefectoPorProceso,
} = storeToRefs(configuracionesPorDefectoStore);
const { tipoItemMezcla, tipoItemComponente, calculoMaterialExtrusion } =
  storeToRefs(configuracionStore);

// COTI-642: columna "Proceso" — de qué proceso del elemento proviene cada material. Se
// muestra sólo si la categoría tiene el flag ProcesoPrecedente. No es obligatoria.
const procesosDelElementoInject = inject(
  'procesosDelElemento',
  computed(() => []),
);
const procesosDelElementoResuelto = computed(() =>
  props.procesosDelElemento && props.procesosDelElemento.length > 0
    ? props.procesosDelElemento
    : procesosDelElementoInject.value || [],
);
const mostrarColumnaProceso = computed(() => {
  if (props.categoria?.ProcesoPrecedente === true) return true;
  if (props.categoria?.CategoriaMaterial?.ProcesoPrecedente === true) return true;
  // Reload: el flag vive en la relación proceso↔categoría del catálogo de proceso.
  const codigo = props.categoria?.Codigo;
  return (props.proceso?.ProcesoElementoTipoCategoriaMaterial || []).some(
    (rel) =>
      rel?.ProcesoPrecedente === true &&
      (rel?.CodigoCategoriaMaterial === codigo || rel?.CategoriaMaterial?.Codigo === codigo),
  );
});
const opcionesProcesoOrigen = computed(() =>
  procesosDelElementoResuelto.value
    .map((p, i) => ({
      _uid: p._uid,
      ordenGlobal: p.ordenGlobal ?? i + 1,
      descripcion: p.descripcion ?? p.Proceso?.Descripcion ?? `Proceso ${i + 1}`,
      codigoMaterialResultante:
        p.codigoMaterialResultante ??
        p.CodigoMaterialResultante ??
        p.MaterialResultante?.Codigo ??
        null,
      descripcionMaterialResultante:
        p.descripcionMaterialResultante ??
        p.MaterialResultante?.DescripcionInterna ??
        p.MaterialResultante?.Descripcion ??
        null,
    }))
    .filter((p) => p._uid && p._uid !== props.procesoUid),
);

// COTI-642 (49677): un proceso que genera un material resultante concreto (una Extrusión) sólo
// puede ser el origen de una fila cuyo material sea EXACTAMENTE ese, comparando por código.
// Si la fila todavía no tiene material elegido, no se bloquea nada.
function procesoOrigenIncompatibleConFila(opt, row) {
  return procesoOrigenIncompatibleConMaterial(opt, row?.Material?.Codigo);
}

// Texto del tooltip que explica por qué una opción de proceso origen está deshabilitada.
function motivoProcesoOrigenDeshabilitado(opt) {
  const material = opt?.descripcionMaterialResultante
    ? `«${opt.descripcionMaterialResultante}»`
    : `código ${opt?.codigoMaterialResultante}`;
  return (
    `Este proceso genera el material ${material}. Sólo puede ser el origen de una fila ` +
    `cuyo material sea exactamente ese.`
  );
}

// Barrera 2 (al confirmar cotización / OT / ET): la fila ya tiene elegido un proceso origen que
// genera OTRO material. Se marca en rojo y se reporta al registro de errores del documento.
function filaProcesoOrigenInvalida(row) {
  const uid = row?.ProcesoOrigenUid;
  if (typeof uid !== 'string' || uid.length === 0) return false;
  const opt = opcionesProcesoOrigen.value.find((o) => o._uid === uid);
  if (!opt) return false; // origen colgado: lo poda `podarProcesoOrigenInvalido`, no es este error
  return procesoOrigenIncompatibleConFila(opt, row);
}

// VARIABLES LOCALES
const IsProcesoExtrusion = computed(() => props.proceso?.Codigo === 30);

/**
 * En extrusión la densidad solo entra en el cálculo del material cuando el modo configurado es
 * espesor x densidad; con calculo_material_extrusion en 'gramaje' la columna no aporta nada.
 */
const requiereDensidadExtrusion = computed(
  () => IsProcesoExtrusion.value && calculoMaterialExtrusion.value === 'espesor_densidad',
);

const bitVisible = (mask) => (Number(mask) & Number(currentModule)) === Number(currentModule);
const tornilloCollapseState = ref({});
function toggleTornillo(n) {
  tornilloCollapseState.value[n] = tornilloCollapseState.value[n] === false;
}
const materialesRaw = ref([]);
const materialesMezcla = ref([]);

const materialesMezclaConSeleccionados = computed(() => {
  const list = [...materialesMezcla.value];
  const existingCodes = new Set(list.map((m) => m.Codigo));
  for (const tornillo of props.elementoProcesoTornillos || []) {
    const mat = tornillo.MaterialMezcla;
    if (mat?.Codigo && !existingCodes.has(mat.Codigo)) {
      list.unshift(mat);
      existingCodes.add(mat.Codigo);
    }
  }
  return list;
});
const atributosDinamicos = ref([]);
const aniloxOptions = ref([]);
const cintaOptions = ref([]);
const loadingSearch = ref({ CodigoAnilox: false, CodigoCinta: false });
const tintaCachePorColor = ref(new Map());

const ladoAplicacionOptions = [
  { value: 'Frente', label: 'Frente' },
  { value: 'Liner', label: 'Liner' },
  { value: 'Adhesivo', label: 'Adhesivo' },
];

const localModel = computed({
  get: () => props.modelValue,
  set: (value) => {
    emits('update:modelValue', { ...value });
  },
});

const localModelTornillos = computed({
  get: () => props.elementoProcesoTornillos,
  set: (value) => {
    emits('update:ElementoProcesoTornillos', value);
  },
});

const TINTA_GENERICA = Object.freeze({
  Codigo: 2,
  DescripcionInterna: 'Tinta Generica',
  Activo: true,
});

const invalidateColorCache = (row) => {
  const colorCode = Number(row?.CodigoColor) || 0;
  if (colorCode) tintaCachePorColor.value.delete(colorCode);
};

const dedupeByCodigo = (list = []) => {
  const seen = new Set();
  return (list || []).filter((m) => {
    const code = Number(m?.Codigo);
    if (!Number.isFinite(code) || seen.has(code)) return false;
    seen.add(code);
    return true;
  });
};

const ordenarPorDescripcion = (list = []) =>
  [...(list || [])].sort((a, b) =>
    (a?.DescripcionInterna || '').localeCompare(b?.DescripcionInterna || '', 'es', {
      sensitivity: 'base',
    }),
  );

const makeTintaSuggest = (row) => {
  return async (query, cb) => {
    const includeTintaGenerica = !isBarnizCategory.value;

    let q = (query || '').trim();
    if (row.MaterialDesc && q === row.MaterialDesc.trim()) {
      q = '';
    }

    const colorCode = Number(row?.CodigoColor) || 0;
    if (colorCode === 0) {
      try {
        const base = await searchTintaByColorHTTP(q, props.categoria?.Codigo, null);
        const list = Array.isArray(base) ? base : base && base.Codigo ? [base] : [];
        const ordenada = ordenarPorDescripcion(list);
        const result = includeTintaGenerica ? [TINTA_GENERICA, ...ordenada] : ordenada;
        return cb(dedupeByCodigo(result));
      } catch (e) {
        return cb(includeTintaGenerica ? [TINTA_GENERICA] : []);
      }
    }
    let base = tintaCachePorColor.value.get(colorCode);

    if (!base) {
      try {
        const response = await searchTintaByColorHTTP('', props.categoria?.Codigo, colorCode);

        let list = [];

        if (Array.isArray(response)) {
          list = response;
        } else if (response && Array.isArray(response.data)) {
          list = response.data;
        } else if (response && response.Codigo) {
          list = [response];
        }

        base = list;
        tintaCachePorColor.value.set(colorCode, base);
      } catch (e) {
        console.error(e);
        base = [];
      }
    }

    let filtered = base;
    if (q) {
      const s = q.toLowerCase();
      filtered = base.filter((m) => {
        const a = (m.DescripcionInterna || '').toLowerCase();
        return a.includes(s);
      });
    }

    const ordenada = ordenarPorDescripcion(filtered);
    const finalResult = dedupeByCodigo(
      includeTintaGenerica ? [TINTA_GENERICA, ...ordenada] : ordenada,
    );

    cb(finalResult);
  };
};

const handleSeleccionarTintaMaterial = (row, item) => {
  row.Material = { ...item };
  row.MaterialDesc = item.DescripcionInterna;
  copyMaterialAttributes(item, row);
  emitChanges();
};

const getCategoriasDelProcesoActual = () => {
  const rels = props.proceso?.ProcesoElementoTipoCategoriaMaterial || [];
  const catsDirectas = props.proceso?.CategoriasMaterial || [];
  const ids = new Set();
  rels.forEach((r) => {
    if (r.CodigoCategoriaMaterial) ids.add(Number(r.CodigoCategoriaMaterial));
    if (r.CategoriaMaterial?.Codigo) ids.add(Number(r.CategoriaMaterial.Codigo));
  });
  catsDirectas.forEach((c) => {
    if (c.Codigo) ids.add(Number(c.Codigo));
  });
  return ids;
};

const collectCategoriasEnSeccion1 = () => {
  const elem = currentElemento.value;
  const catSet = new Set();
  if (!elem) return catSet;
  const detalles = elem.ElementoGrupoDetalle || elem.Detalle || [];
  if (Array.isArray(detalles)) {
    detalles.forEach((det) => {
      const procesos = det.ElementoTipo?.ProcesoElementoTipo || [];
      if (Array.isArray(procesos)) {
        procesos.forEach((pet) => {
          if (pet.CodigoSeccion === 1 && pet.Proceso) {
            const rels = pet.Proceso.ProcesoElementoTipoCategoriaMaterial || [];
            rels.forEach((rel) => {
              const cod = rel.CodigoCategoriaMaterial || rel.CategoriaMaterial?.Codigo;
              if (cod) catSet.add(Number(cod));
            });
            const cats = pet.Proceso.CategoriasMaterial || [];
            cats.forEach((c) => {
              if (c.Codigo) catSet.add(Number(c.Codigo));
            });
          }
        });
      }
    });
  }
  return catSet;
};

const showAnilox = computed(() => {
  const globalCats = collectCategoriasEnSeccion1();
  if (globalCats.has(Number(MaterialCategoria.ANILOX))) return true;
  const localCats = getCategoriasDelProcesoActual();
  return localCats.has(Number(MaterialCategoria.ANILOX));
});

const showCinta = computed(() => {
  const globalCats = collectCategoriasEnSeccion1();
  if (globalCats.has(Number(MaterialCategoria.CINTA_BIFAZ))) return true;
  const localCats = getCategoriasDelProcesoActual();
  return localCats.has(Number(MaterialCategoria.CINTA_BIFAZ));
});

const TINTA_FIXED_COLS = [
  'CuerpoImpresor', // 1. Cuerpo Impresor
  'CodigoColor', // 2. Color
  'Material', // 3. Tinta
  'LadoAplicacion', // 4. Ubicación
  'CodigoTintaTipo', // 5. Tipo
  'Cobertura', // 6. Porcentaje
  'MatrizAdicional', // 7. Matriz
];

const BARNIZ_FIXED_COLS = [
  'CuerpoImpresor', // 1. Cuerpo Impresor
  'Material', // 2. Tinta
  'LadoAplicacion', // 3. Ubicación
  'Cobertura', // 4. Porcentaje
  'MatrizAdicional', // 5. Matriz
];

const isTintaCategory = computed(() => {
  const code = Number(props.categoria?.Codigo || 0);
  return code === 7 || code === 8;
});

const isBarnizCategory = computed(() => {
  const descripcionCategoria = String(props.categoria?.Descripcion || '').trimStart();
  return (
    descripcionCategoria.toLowerCase().startsWith('barniz ') ||
    descripcionCategoria.toLowerCase() === 'barniz'
  );
});

const materialInputPlaceholder = computed(() => {
  if (isBarnizCategory.value) return 'Ingresar barniz';
  if (isTintaCategory.value) return 'Ingresar tinta';
  return 'Ingresar color/tinta';
});

const DYN_ATTRS = [
  'Ancho',
  'Alto',
  'Largo',
  'Espesor',
  'Gramaje',
  'Densidad',
  'Diametro',
  'Rendimiento',
  'CuerpoImpresor',
  'Color',
  'CodigoColor',
  'LadoAplicacion',
  'MatrizAdicional',
  'Kilos',
  'CodigoAnilox',
  'CodigoCinta',
  'CodigoTintaTipo',
  'Material',
  'Rigidez',
  'Rasgado',
  'Punzonado',
  'TemperaturaSellado',
  'Termoencogible',
  'Retortable',
  'Transparencia',
  'Brillo',
  'Opacidad',
  'Base',
  'ComponentePrincipal',
  'Solvente',
  'CompatibilidadAdhesivo',
  'CompatibilidadTinta',
  'AptoAlimentos',
  'Laminable',
  'Termorresistente',
  'ResistenciaQuimica',
  'ResistenciaLuz',
  'ResistenciaFriccion',
  'TratamientoCorona',
  'CoeficienteFriccion',
  'Antiestatico',
  'Reciclable',
  'Biodegradable',
  'Compostable',
  'LibreDeSolventesAromaticos',
  'BajoVOC',
  'Viscosidad',
  'Peso',
  'Curado',
  'Forma',
  'TipoFlauta',
  'CostoMaterial',
  'CantidadMaterial',
];

/**
 * Tipos de columna cuyo valor es un CÓDIGO que sólo se puede mostrar resolviendo una relación
 * (color, anilox/cinta, tipo de tinta, cuerpo impresor, lado de aplicación). Aunque la columna
 * salga de `DYN_ATTRS`, el material no trae esa relación expandida, así que mostrar el valor
 * crudo sería un número suelto. Esas columnas no se tratan como atributo del material en la
 * fila real y siguen usando sus ramas específicas, que sí resuelven la etiqueta.
 */
const TIPOS_COLUMNA_POR_RELACION = [
  'color_picker',
  'remote_select',
  'cuerpo_impresor_select',
  'side_select',
  'tinta_type_select',
  'tinta_autocomplete',
];

const ATTR_TYPE = {
  CuerpoImpresor: 'cuerpo_impresor_select',
  Color: 'color_picker',
  CodigoColor: 'color_picker',
  Forma: 'select',
  LadoAplicacion: 'side_select',
  CodigoTintaTipo: 'tinta_type_select',
  CodigoAnilox: 'remote_select',
  CodigoCinta: 'remote_select',
  Cobertura: 'number',
  MatrizAdicional: 'number',
  Kilos: 'number',
  Material: 'tinta_autocomplete',
  Ancho: 'number',
  Alto: 'number',
  Largo: 'number',
  Espesor: 'number',
  Gramaje: 'number',
  CostoMaterial: 'number',
  CantidadMaterial: 'number',
  Densidad: 'number',
  Diametro: 'number',
  Rendimiento: 'number',
  TemperaturaSellado: 'number',
  Peso: 'number',
  Rigidez: 'text',
  Rasgado: 'text',
  Punzonado: 'text',
  Termoencogible: 'text',
  Retortable: 'text',
  Transparencia: 'text',
  Brillo: 'text',
  Opacidad: 'text',
  Base: 'text',
  ComponentePrincipal: 'text',
  Solvente: 'text',
  CompatibilidadAdhesivo: 'text',
  CompatibilidadTinta: 'text',
  AptoAlimentos: 'text',
  Laminable: 'text',
  Termorresistente: 'text',
  ResistenciaQuimica: 'text',
  ResistenciaLuz: 'text',
  ResistenciaFriccion: 'text',
  TratamientoCorona: 'text',
  CoeficienteFriccion: 'text',
  Antiestatico: 'text',
  Reciclable: 'text',
  Biodegradable: 'text',
  Compostable: 'text',
  LibreDeSolventesAromaticos: 'text',
  BajoVOC: 'text',
  Viscosidad: 'text',
  Curado: 'text',
  TipoFlauta: 'text',
};

const NUMBER_META = {
  Ancho: { precision: 4, step: 0.0001 },
  Alto: { precision: 3, step: 0.001 },
  Largo: { precision: 3, step: 0.001 },
  Espesor: { precision: 3, step: 0.001 },
  Gramaje: { precision: 3, step: 0.001 },
  Densidad: { precision: 4, step: 0.0001 },
  Diametro: { precision: 3, step: 0.001 },
  Rendimiento: { precision: 3, step: 0.001 },
  TemperaturaSellado: { precision: 4, step: 0.0001 },
  Peso: { precision: 4, step: 0.0001 },
  Cobertura: { precision: 2, step: 1 },
  MatrizAdicional: { precision: 0, step: 1 },
  Kilos: { precision: 3, step: 0.001 },
  CantidadMaterial: { precision: 3, step: 0.001 },
  CostoMaterial: { precision: 3, step: 0.001 },
};

// `CantidadMaterial`/`CostoMaterial` son los nombres del bitfield de visibilidad en
// MaterialCategoria, pero las columnas reales en
// EspecificacionTecnicaElementoProcesoMateriales (y equivalentes de Solicitud/Cotización/OT) son
// `Cantidad` y `Costo`, sin sufijo.
const VALUE_PROP = {
  Color: 'CodigoColor',
  Forma: 'Forma',
  CantidadMaterial: 'Cantidad',
  CostoMaterial: 'Costo',
};

const TOLERANCIA_PORCENTAJE = 0.01;

// ====== AGRUPAMIENTO POR TORNILLO ======
function rowsByTornillo(n) {
  return (localModel.value.ElementoMateriales || []).filter((r) => r.NumeroTornillo === n);
}

function sumForTornillo(n) {
  return rowsByTornillo(n).reduce((sum, r) => sum + (Number(r.Porcentaje) || 0), 0);
}

function sumOkForTornillo(n) {
  return Math.abs(sumForTornillo(n) - 100) <= TOLERANCIA_PORCENTAJE;
}

const errorSumaMaterialesTornillos = computed(() => {
  if (!IsProcesoExtrusion.value) return false;
  const tornillos = props.elementoProcesoTornillos || [];
  if (tornillos.length === 0) return false;
  return tornillos.some((t, i) => {
    const n = t?.ItemTornillo ?? i + 1;
    const total = sumForTornillo(n);
    return total > 0 && Math.abs(total - 100) > TOLERANCIA_PORCENTAJE;
  });
});

watch(
  errorSumaMaterialesTornillos,
  (hayError) => {
    reportarErrorSumaMateriales(
      hayError,
      'Los porcentajes de materiales de algún tornillo no suman 100%.',
    );
  },
  { immediate: true },
);

// COTI-642 (49677): barrera 2 — al confirmar cotización / OT / ET, si alguna fila tiene un
// proceso de origen que genera un material distinto al de la fila, se bloquea la confirmación
// (registro de errores del documento) además de pintarse la fila en rojo en la grilla.
//
// El `Set` se recalcula al iterar las filas (rastrea `row.ProcesoOrigenUid` / `row.Material`),
// así que al elegir un proceso permitido la fila deja de estar en el set. `claseFilaMaterial`
// es un `computed` que devuelve una función: al cambiar el set cambia la referencia y `el-table`
// vuelve a evaluar `row-class-name` (una función suelta no se re-evalúa al mutar la fila).
const filasProcesoOrigenInvalido = computed(() => {
  const set = new Set();
  for (const row of localModel.value?.ElementoMateriales || []) {
    if (filaProcesoOrigenInvalida(row)) set.add(row);
  }
  return set;
});
const claseFilaMaterial = computed(
  () =>
    ({ row }) =>
      filasProcesoOrigenInvalido.value.has(row) ? 'fila-material-origen-invalido' : '',
);

const reportarErrorProcesoOrigen = useErrorRegistro('materialProcesoOrigenIncompatible');
watch(
  () => filasProcesoOrigenInvalido.value.size > 0,
  (hayError) => {
    reportarErrorProcesoOrigen(
      hayError,
      'Hay materiales asociados a un proceso de origen que genera un material distinto. ' +
        'Revise la columna "Proceso" de la grilla de materiales.',
    );
  },
  { immediate: true },
);

function getDimensionDisplay(row, prop) {
  return milimeterVisualTo(row?.[prop], unidadVisual.value);
}

function setDimensionValue(row, prop, visualVal) {
  const mmVal = visualToMilimeter(visualVal, unidadVisual.value);
  row[prop] = mmVal;
  if (prop === 'Ancho') {
    const anchoFijo = Number(row?.Material?.Ancho);
    if (aplicaRegla.value && selectedMaterialAnchoMM && !(anchoFijo > 0)) {
      onUserChangeAncho(row, mmVal);
    }
  }
  emitChanges();
}

function onNumberChange(row, col, val) {
  if (isDimensionesProp(col.prop)) {
    setDimensionValue(row, col.prop, val);
    return;
  }

  if (col.prop === 'MatrizAdicional') {
    if (val === null || val === undefined || val === '') {
      row[col.prop] = null;
    } else {
      const parsed = Number(val);
      row[col.prop] = Number.isFinite(parsed) ? Math.trunc(parsed) : null;
    }
    emitChanges();
    return;
  }

  row[col.modelKey] = val;
  emitChanges();
}
const unidadCategoria = computed(() => {
  const cod = props?.categoria?.CodigoUnidadMedidaDimensiones;
  if (cod === UnidadMedida.MILIMETRO) return 'mm';
  if (cod === UnidadMedida.PULGADA) return 'in';
  if (cod === UnidadMedida.CENTIMETRO) return 'cm';
  return 'mm';
});

const unidadVisual = computed(() => {
  if (unidadCategoria.value === 'mm') {
    return unidadImposicion.value;
  }
  return unidadCategoria.value;
});

const showPorcentajeMaterial = computed(() => IsProcesoExtrusion.value || props.validarPorcentaje);

const hasRows = computed(() => (localModel.value?.ElementoMateriales || []).length > 0);
const shouldValidatePorcentaje = computed(
  () => props.validarPorcentaje && IsProcesoExtrusion.value && hasRows.value,
);
const validaDesdeCategoriaProp = computed(() =>
  Boolean(props?.categoria?.ValidaAnchoMaterial === true),
);
const validaDesdeRows = computed(() => {
  const rows = localModel.value?.ElementoMateriales || [];
  return rows.some(
    (r) => r?.Material?.MaterialTipo?.MaterialCategoria?.ValidaAnchoMaterial === true,
  );
});
// Definición única en use_aplica_regla.js. Acá se restringe a los módulos donde ya hay
// material cargado, y se suma la condición de que la categoría valide el ancho.
//
// OJO: la lista original decía `ElementoBase.CONSUMIBLES` (plural), que NO existe en el enum
// —es CONSUMIBLE— y por lo tanto era `undefined`: Consumible nunca entraba, y un elemento sin
// `currentElementoBase` entraba por accidente. Se dejan sólo los elementos base que
// efectivamente aplican: CONSUMIBLE sigue afuera hasta que se defina si corresponde.
//
// OFFSET (COTI-502) entra acá porque es lo que permite que este componente publique el ancho
// del material en `selectedMaterialAnchoMM`, de donde `input_suaje` autocompleta el campo
// "Ancho Material".
const aplicaRegla = useAplicaRegla({
  modulos: MODULOS_CON_MATERIAL,
  elementosBase: [ElementoBase.ETIQUETA, ElementoBase.FLEXIBLE, ElementoBase.OFFSET],
  condicionExtra: computed(() => validaDesdeCategoriaProp.value || validaDesdeRows.value),
});

const PRETTY = (s) =>
  String(s || '')
    .replace(/([A-Z])/g, ' $1')
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/^./, (c) => c.toUpperCase());
const toOn = (v) => {
  if (typeof v === 'number') return bitVisible(v);
  if (typeof v === 'string') return ['true', '1', 't', 'y', 's'].includes(v.toLowerCase());
  return !!v;
};
const getFlagProviders = () => {
  const base = props?.categoria || {};
  const mats = (localModel.value.ElementoMateriales || []).map(
    (r) => r?.Material?.MaterialTipo?.MaterialCategoria || {},
  );
  return [base, ...mats];
};
function getCatLabels() {
  const fromCategoria = props?.categoria?.MaterialCategoriaEtiquetas;
  if (fromCategoria && typeof fromCategoria === 'object') return fromCategoria;
  const catCodigo = props?.categoria?.Codigo;
  const etiquetasDeMateriales = (() => {
    if (!Array.isArray(materialesRaw.value) || !catCodigo) return null;
    const mat = materialesRaw.value.find(
      (m) => m?.MaterialTipo?.MaterialCategoria?.Codigo === catCodigo,
    );
    return mat?.MaterialTipo?.MaterialCategoria?.MaterialCategoriaEtiquetas || null;
  })();
  if (etiquetasDeMateriales && typeof etiquetasDeMateriales === 'object')
    return etiquetasDeMateriales;
  const firstRowLbls = (localModel.value.ElementoMateriales || [])
    .map((r) => r?.Material?.MaterialTipo?.MaterialCategoria?.MaterialCategoriaEtiquetas)
    .find((x) => x && typeof x === 'object');
  if (firstRowLbls) return firstRowLbls;
  return {};
}

function recomputeSelectedAnchoMM() {
  if (!aplicaRegla.value || !selectedMaterialAnchoMM) return;
  const rows = localModel.value.ElementoMateriales || [];
  if (rows.length === 0) return;
  let mm = 0;
  for (const r of rows) {
    const fijo = Number(r?.Material?.Ancho);
    const manual = Number(r?.Ancho);

    if (Number.isFinite(manual) && manual > 0) {
      mm = manual;
      break;
    }
    if (Number.isFinite(fijo) && fijo > 0) {
      mm = fijo;
      break;
    }
  }
  selectedMaterialAnchoMM.value = mm || 0;
}

// Materiales ya elegidos en ESTE proceso/categoría según el backend (`GET` de la OP/ET/
// Cotización trae `MaterialesSeleccionadosPorCategoria`, agrupado en todo el documento —
// cubre materiales elegidos en OTRAS instancias de esta grilla para la misma categoría).
const materialesSeleccionadosInyectados = computed(() => {
  const codigoCategoria = props.categoria?.Codigo;
  if (codigoCategoria == null) return [];
  return materialesSeleccionadosPorCategoriaInject.value?.[codigoCategoria] ?? [];
});

// Complemento local: materiales elegidos en ESTA sesión de edición (recién seleccionados,
// todavía no reflejados en el snapshot que devolvió el backend al cargar el documento).
const materialesSeleccionadosLocal = computed(() => {
  const vistos = new Set();
  const seleccionados = [];
  for (const fila of localModel.value?.ElementoMateriales || []) {
    if (fila?.Material?.Codigo != null && !vistos.has(fila.Material.Codigo)) {
      vistos.add(fila.Material.Codigo);
      seleccionados.push(fila.Material);
    }
    for (const real of fila?.MaterialesReales || []) {
      if (real?.Material?.Codigo != null && !vistos.has(real.Material.Codigo)) {
        vistos.add(real.Material.Codigo);
        seleccionados.push(real.Material);
      }
    }
  }
  return seleccionados;
});

// Unión de ambas fuentes — inyectados primero (autoridad del backend), completado con lo
// elegido en esta sesión que el backend todavía no vio.
const materialesSeleccionados = computed(() => {
  const vistos = new Set();
  const combinados = [];
  for (const m of [
    ...materialesSeleccionadosInyectados.value,
    ...materialesSeleccionadosLocal.value,
  ]) {
    if (m?.Codigo == null || vistos.has(m.Codigo)) continue;
    vistos.add(m.Codigo);
    combinados.push(m);
  }
  return combinados;
});

// Tinta/Barniz no listan materiales del endpoint, y sin material de proceso tampoco hay
// qué buscar: en esos casos los selectores sólo muestran los materiales ya elegidos.
const materialesHabilitados = computed(
  () => !isTintaCategory.value && !isBarnizCategory.value && !!props.proceso?.Material,
);

// Da forma a las opciones de cada <input-material> (`filtrar-opciones`): primero los materiales
// ya elegidos, después los cargados del endpoint, con el filtro de ancho mínimo si aplica.
// OFFSET queda afuera del filtro: entra en `aplicaRegla` sólo para publicar el ancho del
// material (COTI-502). `anchoMinimoMM` es la fórmula de etiqueta en rollo (MedidaEje por
// EtiquetasEje) y no considera "Validar bocas" ni que el pliego puede girarse, así que en
// offset ocultaba papeles válidos del listado.
function filtrarOpcionesMateriales(cargados) {
  const minMM = Number(anchoMinimoMMInjected?.value ?? NaN);
  const aplicaFiltroAncho =
    currentElementoBase !== ElementoBase.OFFSET &&
    aplicaRegla.value &&
    !!minMM &&
    !Number.isNaN(minMM);

  const vistos = new Set();
  const combinados = [];
  for (const m of materialesSeleccionados.value) {
    if (m?.Codigo == null || vistos.has(m.Codigo)) continue;
    vistos.add(m.Codigo);
    combinados.push(m);
  }
  for (const m of cargados || []) {
    if (m?.Codigo == null || vistos.has(m.Codigo)) continue;
    if (aplicaFiltroAncho) {
      const a = m?.Ancho;
      const cumpleAncho = a == null || Number(a) === 0 || Number(a) >= minMM;
      if (!cumpleAncho) continue;
    }
    vistos.add(m.Codigo);
    combinados.push(m);
  }
  return combinados;
}

// ══════════════════════════════════════════════════════════════════════════════
// COTI-635 — materiales reales (grilla en árbol, sólo ET/OT)
// ══════════════════════════════════════════════════════════════════════════════

let nextRealTmpId = 0;
const nuevoIdTemporal = () => `tmp-${Date.now()}-${nextRealTmpId++}`;

/**
 * COTI-635: igual patrón que `isMultiMaterialEffective` (más abajo) — busca,
 * en la config de "categorías asociadas a proceso" (pantalla de producto
 * personalizado, `RelProcesoElementoTipoCategoriaMaterial.CantidadManual`),
 * si esta categoría admite materiales reales para este proceso.
 *
 * Reemplaza la exclusión hardcodeada de Tinta que se probó primero: ahora es
 * el usuario quien decide, por proceso+categoría, dónde habilitarlo — no
 * queda atado al tipo de categoría en el código.
 */
const isCantidadManualEffective = computed(() => {
  const rels = Array.isArray(props.proceso?.ProcesoElementoTipoCategoriaMaterial)
    ? props.proceso.ProcesoElementoTipoCategoriaMaterial
    : [];
  const myCatCode = Number(props.categoria?.Codigo ?? props.categoria?.CodigoCategoria ?? 0);
  const config = rels.find((rel) => {
    const relCatCode = Number(rel.CodigoCategoriaMaterial || rel.CategoriaMaterial?.Codigo || 0);
    return relCatCode === myCatCode;
  });
  return !!config?.CantidadManual;
});

/** Habilita la grilla de reales: sólo en ET/OT y sólo si la categoría lo tiene configurado. */
const arbolRealesActivo = computed(
  () => props.mostrarMaterialesReales && isCantidadManualEffective.value,
);

/**
 * En ET los materiales alternativos sólo definen el material: la cantidad real se carga en OT.
 * Por eso ahí no se muestran ni el campo de cantidad ni la columna de necesidad/diferencia.
 */
const mostrarCantidadReales = computed(
  () => arbolRealesActivo.value && Number(currentModule) !== Number(Modules.ESPECIFICACION_TECNICA),
);

// COTI-635: en OT la necesidad y los reales se resuelven con el helper por unidad del recurso;
// ET conserva el criterio por unidad efectiva del material (`resolverCodigoUnidadReal`).
const esOrdenProduccion = computed(
  () => Number(currentModule) === Number(Modules.ORDEN_PRODUCCION),
);

/**
 * Vista en árbol de `ElementoMateriales`: cada teórico es padre, sus
 * `MaterialesReales` son hijos. Cuando `arbolRealesActivo` es false
 * devuelve el array tal cual, sin ninguna mutación — cero cambio de
 * comportamiento para Solicitud/Cotización y para Tinta.
 *
 * Muta los objetos originales con metadatos livianos (`_key`, `_tipo`,
 * `children`) en vez de clonarlos: editar `row.Cantidad` en un real sigue
 * escribiendo sobre el mismo objeto que ya está en
 * `ElementoMateriales[i].MaterialesReales`, sin pasos de sync aparte.
 */
const materialesArbol = computed(() => {
  const teoricos = localModel.value?.ElementoMateriales || [];
  if (!arbolRealesActivo.value) return teoricos;
  teoricos.forEach((teorico) => {
    if (!teorico._key) teorico._key = teorico.Codigo ? `teo-${teorico.Codigo}` : nuevoIdTemporal();
    teorico._tipo = 'Teorico';
    if (!Array.isArray(teorico.MaterialesReales)) teorico.MaterialesReales = [];
    teorico.MaterialesReales.forEach((real) => {
      if (!real._key) real._key = real.Codigo ? `real-${real.Codigo}` : nuevoIdTemporal();
      real._tipo = 'Real';
      // COTI-635 (8.13): `CodigoUnidadMedida` nulo en un real ya persistido es dato anterior a
      // este cambio — esta rama todavía no se liberó, así que no hay reales productivos con el
      // campo poblado. Se asume que esa fila fue cargada en la unidad que la UI asignaría hoy
      // (secundaria del material, con fallback a la principal) y se completa acá para que la
      // abreviatura mostrada junto al input y el próximo guardado queden consistentes. Es una
      // suposición sobre datos preexistentes de desarrollo, no un dato confirmado por el
      // backend. En OT no se completa: un real sin unidad cae en "otra unidad" y queda marcado.
      if (!esOrdenProduccion.value && real.CodigoUnidadMedida == null) {
        real.CodigoUnidadMedida = resolverCodigoUnidadReal(real.Material);
      }
    });
    teorico.children = teorico.MaterialesReales;
  });
  return teoricos;
});

// COTI-635 (8.12/8.13): la conversión entre unidad principal/secundaria sigue en
// `@/shared/utils/material_unidades_conversion.js` (funciones puras, con su spec) y la usa sólo
// la carga de reales de ET — ver `resolverCodigoUnidadReal`, `abreviaturaUnidadReal`,
// `necesidadTeorica`, `convertirPrincipalAUnidadReal` y `redondearCantidadDual`. La necesidad,
// el real y la diferencia de OT salen de `@/shared/utils/necesidad_unidad_recurso.js`.

/** Resumen Necesidad / Real / Diferencia de un teórico de OT, en la unidad activa. */
function resumenOT(teorico) {
  return resumenCantidades(teorico, props.unidadRecurso);
}

// COTI-635: al cambiar el recurso (o recargar filas por unidad tras guardar) el teórico cambia de
// unidad activa y sus reales quedarían en la unidad vieja. Se convierten con el cociente de los
// `Total` del motor (`convertirRealAUnidad`); si no hay factor el real no se toca y conserva el
// aviso de "otra unidad". Tras convertir el real ya está en la unidad activa, así que una
// segunda pasada no cambia nada (sin bucle) y `emitChanges` sólo corre si algo cambió.
function convertirRealesAUnidadActiva() {
  if (!esOrdenProduccion.value) return;
  let huboCambios = false;
  for (const teorico of localModel.value?.ElementoMateriales || []) {
    if (!Array.isArray(teorico.MaterialesReales) || !teorico.MaterialesReales.length) continue;
    const { codigo } = unidadActiva(teorico, props.unidadRecurso);
    for (const real of teorico.MaterialesReales) {
      const cantidad = convertirRealAUnidad(real, teorico, codigo);
      if (cantidad == null) continue;
      real.Cantidad = cantidad;
      real.CodigoUnidadMedida = codigo;
      // El mapper del backend prioriza la relación `UnidadMedida` sobre `CodigoUnidadMedida`.
      real.UnidadMedida = null;
      huboCambios = true;
    }
  }
  if (huboCambios) emitChanges();
}

function textoNecesidadOT(teorico) {
  const r = resumenOT(teorico);
  return textoCantidad(r.necesidad, r.unidad.abreviatura, formatNumberLocale);
}

function textoRealOT(teorico) {
  const r = resumenOT(teorico);
  return textoCantidad(r.real, r.unidad.abreviatura, formatNumberLocale);
}

function textoDiferenciaOT(teorico) {
  const r = resumenOT(teorico);
  return textoCantidad(r.diferencia, r.unidad.abreviatura, formatNumberLocale);
}

// `info` si no hay necesidad (diferencia "—"), `success` en 0, `warning` en cualquier otro caso.
function tipoTagDiferencia(teorico) {
  const { diferencia } = resumenOT(teorico);
  if (diferencia == null) return 'info';
  return diferencia === 0 ? 'success' : 'warning';
}

function mensajeOrigenOT(teorico) {
  return mensajeOrigen(resumenOT(teorico).unidad, props.unidadRecurso);
}

// La marca no aplica cuando no hay filas por unidad: no hay nada "viejo" que avisar.
function mostrarPendienteRecalculo(teorico) {
  return props.recursoPendienteRecalculo && resumenOT(teorico).unidad.origen !== 'sin-filas';
}

/** Teórico al que pertenece una fila real (búsqueda por `_key`). */
function teoricoDeReal(real) {
  return (localModel.value?.ElementoMateriales || []).find((t) =>
    (t.MaterialesReales || []).some((r) => r._key === real._key),
  );
}

/** `true` si el real de OT no está cargado en la unidad activa de su teórico. */
function realEnOtraUnidadOT(real) {
  const teorico = teoricoDeReal(real);
  if (!teorico) return false;
  return realEnOtraUnidad(real, resumenOT(teorico).unidad);
}

// Sufijo del input real: en OT, la unidad activa si el real está en ella y, si no, la propia
// del real (la relación `UnidadMedida` que trae el GET); en ET, la unidad efectiva de siempre.
function abreviaturaRealMostrada(real) {
  if (!esOrdenProduccion.value) return abreviaturaUnidadReal(real);
  const teorico = teoricoDeReal(real);
  if (!teorico) return real.UnidadMedida?.Abreviatura || '';
  const { unidad } = resumenOT(teorico);
  return realEnOtraUnidad(real, unidad) ? real.UnidadMedida?.Abreviatura || '' : unidad.abreviatura;
}

function avisoRealEnOtraUnidad(real) {
  if (!esOrdenProduccion.value || !realEnOtraUnidadOT(real)) return null;
  const { unidad } = resumenOT(teoricoDeReal(real));
  const abreviaturaReal = real.UnidadMedida?.Abreviatura || 'otra unidad';
  return `Cargado en ${abreviaturaReal}: no suma a la necesidad en ${unidad.abreviatura}.`;
}

// COTI-635 (8.13): se ejecuta al elegir otro material en el selector de una fila real — la
// unidad secundaria puede ser distinta a la del material anterior, así que hay que
// recalcularla (no sólo setearla al crear la fila en `agregarMaterialReal`).
function handleSeleccionarMaterialReal(row) {
  // COTI-635: en OT la unidad la decide el teórico padre (la del recurso o su respaldo), no el
  // material elegido; así los reales de un mismo teórico quedan en la misma escala.
  const teorico = esOrdenProduccion.value ? teoricoDeReal(row) : null;
  row.CodigoUnidadMedida = teorico
    ? unidadActiva(teorico, props.unidadRecurso).codigo
    : resolverCodigoUnidadReal(row.Material);
  // La relación `UnidadMedida` que bajó el backend describe el material ANTERIOR. Si no se
  // limpia queda como respaldo vigente en `abreviaturaUnidadReal` y el sufijo mostraría la
  // unidad vieja al lado de una cantidad que ya es de otro material.
  row.UnidadMedida = null;
  emitChanges();
}

/**
 * Valor de una columna de atributo para una fila REAL, leído SIEMPRE del material de esa
 * fila.
 *
 * Los atributos del material no son dato de la fila real: las tablas
 * `*ElementoProcesoMaterialesReal` guardan únicamente material, cantidad, costo y unidad (ver
 * `schema.prisma`), así que un real ya persistido vuelve del backend sin `Ancho`, `Gramaje`
 * ni ninguno de estos campos. Leerlos de `row[...]` sólo funcionaba mientras la fila seguía
 * en memoria con la copia que hacía `agregarMaterialReal`, y mostraba "—" apenas se guardaba
 * y recargaba el documento. El material es la única fuente, y además es la correcta: si el
 * usuario cambia el material de la fila real, los atributos que se muestran son los del
 * material nuevo, sin ningún paso de sincronización.
 *
 * Usa la misma resolución que `copyMaterialAttributes` para no divergir: los nativos por
 * `modelKey` con respaldo en `prop` (la diferencia la marca `VALUE_PROP`), y los dinámicos
 * desde `AtributosAdicionales` con respaldo en el campo plano.
 */
function valorAtributoDelMaterialReal(row, col) {
  const material = row?.Material;
  if (!material) return null;

  if (col.isDynamic) {
    const adicionales = material.AtributosAdicionales;
    const valorAdicional =
      adicionales && typeof adicionales === 'object' ? adicionales[col.prop] : undefined;
    return valorAdicional ?? material[col.prop] ?? null;
  }

  return material[col.modelKey] ?? material[col.prop] ?? null;
}

/**
 * Texto grisado de una columna de atributo en una fila real. Replica cómo se ve el mismo dato
 * en la fila teórica editable: los numéricos con la precisión de su columna (igual que el
 * `el-input-number`), los select por etiqueta y no por clave, y los booleanos como Sí/No.
 *
 * Las dimensiones se muestran tal cual vienen del material, que es la misma escala en la que
 * el teórico guarda y muestra `Ancho`/`Alto`/`Largo`; no se aplica ninguna conversión extra
 * para no inventar una diferencia entre las dos filas.
 */
function textoAtributoMaterialReal(row, col) {
  const valor = valorAtributoDelMaterialReal(row, col);
  if (valor === null || valor === undefined || valor === '') return '—';

  if (col.type === 'switch' || typeof valor === 'boolean') return valor ? 'Sí' : 'No';

  if (col.type === 'select') {
    const opciones = col.opciones || [];
    const valores = Array.isArray(valor) ? valor : [valor];
    return valores
      .map((v) => opciones.find((opt) => opt.Clave === v)?.Etiqueta ?? String(v))
      .join(', ');
  }

  if (col.type === 'number') {
    const numero = Number(valor);
    return Number.isFinite(numero) ? numero.toFixed(col.precision ?? 0) : String(valor);
  }

  return String(valor);
}

function cantidadInicialReal(teorico, esPrimero) {
  if (!esPrimero) return 0;
  if (esOrdenProduccion.value) return semillaPrimerReal(teorico, props.unidadRecurso);
  return redondearCantidadDual(
    convertirPrincipalAUnidadReal(necesidadTeorica(teorico), teorico.Material),
  );
}

function agregarMaterialReal(teorico) {
  const esPrimero = (teorico.MaterialesReales || []).length === 0;
  teorico.MaterialesReales = teorico.MaterialesReales || [];
  const real = {
    _key: nuevoIdTemporal(),
    _tipo: 'Real',
    // COTI-635 (8.9): se preselecciona el material del teórico para facilitar la carga.
    // Se clona (no se referencia el mismo objeto) para que la fila real pueda cambiar de
    // material más adelante sin afectar al teórico.
    Material: teorico.Material ? { ...teorico.Material } : {},
    // `Porcentaje` y `Color` (el objeto completo, no sólo `CodigoColor`) son datos de la FILA
    // del teórico, no atributos del material: no se pueden derivar del material real, así que
    // se copian para que la fila arranque con "los mismos datos" completos.
    Porcentaje: teorico.Porcentaje,
    Color: teorico.Color ? { ...teorico.Color } : null,
    // Si el usuario no distribuye manualmente, el consumo se asume del
    // primer material real hasta que redistribuya (regla del ticket). Convertida a la unidad
    // EFECTIVA del real (8.13): antes arrancaba con la necesidad tal cual, en unidad principal,
    // que ya no es la escala en la que se carga esta cantidad.
    // En OT (COTI-635) la semilla es la necesidad mostrada en la unidad activa del teórico.
    Cantidad: cantidadInicialReal(teorico, esPrimero),
    // COTI-635 (8.13): unidad en la que queda cargada/persistida esta cantidad — viaja al
    // backend en `CodigoUnidadMedida`.
    // En OT es la unidad activa del teórico (la del recurso o su respaldo).
    CodigoUnidadMedida: esOrdenProduccion.value
      ? unidadActiva(teorico, props.unidadRecurso).codigo
      : resolverCodigoUnidadReal(teorico.Material),
    // El mapper del backend prioriza la relación `UnidadMedida` sobre `CodigoUnidadMedida`.
    ...(esOrdenProduccion.value ? { UnidadMedida: null } : {}),
  };
  teorico.MaterialesReales.push(real);
  // Los atributos del material NO se copian a la fila real: se leen del material en el
  // momento de mostrarlos (`valorAtributoDelMaterialReal`). Copiarlos dejaba la fila con una
  // foto que el backend no persiste —esas columnas no existen en
  // `*ElementoProcesoMaterialesReal`— y que quedaba vieja si después se cambiaba el material.
  emitChanges();
}

function quitarMaterialReal(real) {
  const teorico = teoricoDeReal(real);
  if (!teorico) return;
  teorico.MaterialesReales = teorico.MaterialesReales.filter((r) => r._key !== real._key);
  emitChanges();
}

// COTI-635 (8.10): botón "Reservar cantidad" agregado a la fila real, sin lógica todavía — la
// reserva depende de `PermiteReservar` (Fase 8, backend/config pendientes fuera de este
// alcance). Se deja un handler vacío en vez de un `@click` ausente para que quede explícito
// que la falta de comportamiento es intencional y no un olvido.
function reservarCantidad(_real) {
  // Intencionalmente sin implementar: la lógica de reserva llega en un ticket posterior.
}

function canEditAncho(row) {
  if (aplicaRegla.value) {
    return true;
  }
  return true;
}

const totalPorcentaje = computed(() =>
  (localModel.value.ElementoMateriales || []).reduce((total, item) => {
    const v = Number(item?.Porcentaje ?? 0);
    return total + (Number.isFinite(v) ? v : 0);
  }, 0),
);

// Las secciones de tornillo se generan a partir de los tornillos materializados/persistidos
// (props.elementoProcesoTornillos), usando ItemTornillo como número de tornillo.
const listaTornillos = computed(() =>
  (props.elementoProcesoTornillos || []).map((t, i) => t?.ItemTornillo ?? i + 1),
);

const diferenciaPorcentaje = computed(() => 100 - totalPorcentaje.value);
const porcentajeValido = computed(
  () =>
    !shouldValidatePorcentaje.value ||
    Math.abs(diferenciaPorcentaje.value) <= TOLERANCIA_PORCENTAJE,
);
const porcentajeExcedido = computed(
  () => shouldValidatePorcentaje.value && diferenciaPorcentaje.value < -TOLERANCIA_PORCENTAJE,
);
const porcentajeIncompleto = computed(
  () => shouldValidatePorcentaje.value && diferenciaPorcentaje.value > TOLERANCIA_PORCENTAJE,
);
const totalPolimeros = computed(() => {
  const rows = localModel.value.ElementoMateriales || [];

  if (isBarnizCategory.value) {
    return rows.reduce((total, item) => {
      const matrizAdic = Number(item?.MatrizAdicional ?? 0);
      return total + (Number.isFinite(matrizAdic) ? matrizAdic : 0);
    }, 0);
  }

  let countSinCuerpoImpresor = 0;
  const conjuntosUnicosCuerpoYTinta = new Set();
  let sumaMatrizAdic = 0;

  rows.forEach((item) => {
    const cuerpoImpresor = item?.CuerpoImpresor;
    const tieneCuerpoImpresor =
      cuerpoImpresor !== null &&
      cuerpoImpresor !== undefined &&
      String(cuerpoImpresor).trim() !== '';

    if (!tieneCuerpoImpresor) {
      countSinCuerpoImpresor += 1;
    } else {
      const tintaCodigo = item?.Material?.Codigo;
      const tintaDescripcion = item?.MaterialDesc;
      const tintaKey =
        tintaCodigo ??
        String(tintaDescripcion || '')
          .trim()
          .toLowerCase();
      const conjuntoKey = `${String(cuerpoImpresor).trim()}::${String(tintaKey)}`;
      conjuntosUnicosCuerpoYTinta.add(conjuntoKey);
    }

    const matrizAdic = Number(item?.MatrizAdicional ?? 0);
    if (Number.isFinite(matrizAdic)) {
      sumaMatrizAdic += matrizAdic;
    }
  });

  return countSinCuerpoImpresor + conjuntosUnicosCuerpoYTinta.size + sumaMatrizAdic;
});
const showTotalPolimeros = computed(() => isTintaCategory.value || isBarnizCategory.value);

watch(
  () => localModel.value.ElementoMateriales,
  () => {
    recomputeSelectedAnchoMM();
  },
  { deep: true, immediate: true },
);

const emits = defineEmits(['update:modelValue', 'update:ElementoProcesoTornillos']);

function serializeAtributosDinamicos(row) {
  const atributosClaves = row._atributosDinamicos || atributosDinamicos.value.map((d) => d.Clave);
  if (!atributosClaves || atributosClaves.length === 0) return null;
  const atributosObj = {};
  atributosClaves.forEach((clave) => {
    const value = row[clave];
    atributosObj[clave] = value !== undefined ? value : null;
  });
  return atributosObj;
}

function deserializeAtributosDinamicos(row) {
  if (row.Material && row.Material.DescripcionInterna && !row.MaterialDesc) {
    row.MaterialDesc = row.Material.DescripcionInterna;
  }

  if (!row.AtributosAdicionales || typeof row.AtributosAdicionales !== 'object') return;
  try {
    Object.keys(row.AtributosAdicionales).forEach((clave) => {
      const value = row.AtributosAdicionales[clave];
      row[clave] = value;
    });
  } catch (error) {
    console.error('Error deserializando AtributosAdicionales:', error);
  }
}

function prepareForSave() {
  if (!localModel.value?.ElementoMateriales) return localModel.value;
  localModel.value.ElementoMateriales.forEach((row) => {
    row.AtributosAdicionales = serializeAtributosDinamicos(row);
  });
  return localModel.value;
}
defineExpose({ prepareForSave });

function prepareForBackend() {
  if (!localModel.value.ElementoMateriales) return;
  localModel.value.ElementoMateriales.forEach((row) => {
    row.AtributosAdicionales = serializeAtributosDinamicos(row);
  });
}
function emitChanges() {
  prepareForBackend();
  emits('update:modelValue', localModel.value);
}

// COTI-642: al cambiar / limpiar el proceso origen, `ProcesoOrigenUid` es la fuente de verdad.
// Sincroniza el `ItemProcesoOrigen` que pudo haber quedado del backend para que el objeto no
// arrastre un valor viejo si algo lo lee antes de la reestandarización.
function onProcesoOrigenChange(row) {
  if (row && (typeof row.ProcesoOrigenUid !== 'string' || row.ProcesoOrigenUid.length === 0)) {
    row.ItemProcesoOrigen = null;
  }
  emitChanges();
}

async function loadAtributosDinamicos() {
  try {
    const opciones = {};
    if (currentModule) opciones.modulo = Number(currentModule);
    if (props.categoria?.Codigo) opciones.codigoMaterialCategoria = Number(props.categoria.Codigo);
    if (props.codigoElementoTipo) opciones.codigoElementoTipo = Number(props.codigoElementoTipo);

    const definicionesConEditabilidad =
      await atributosDinamicosService.getDefinicionesVisiblesConEditable('Material', opciones);
    atributosDinamicos.value = definicionesConEditabilidad || [];

    if (
      localModel.value?.ElementoMateriales &&
      Array.isArray(localModel.value.ElementoMateriales)
    ) {
      localModel.value.ElementoMateriales.forEach((material) => {
        material._atributosDinamicos = definicionesConEditabilidad.map((d) => d.Clave);
      });
    }
  } catch (error) {
    console.error('Error cargando atributos dinámicos:', error);
    atributosDinamicos.value = [];
  }
}

// === HELPER PARA COLUMNAS DINAMICAS ===
function mapDynamicDefToCol(def) {
  let type = 'text';
  if (def.Tipo === 'number') type = 'number';
  else if (def.Tipo === 'boolean') type = 'switch';
  else if (def.Tipo === 'date') type = 'date';
  else if (def.Tipo === 'select' || def.Tipo === 'multiselect') type = 'select';
  else if (def.Tipo === 'color') type = 'color_picker';

  return {
    prop: def.Clave || 'unknown',
    type,
    modelKey: def.Clave || 'unknown',
    label: def.Etiqueta || 'Sin nombre',
    step: def.Tipo === 'number' ? 0.01 : undefined,
    precision: def.Tipo === 'number' ? 2 : undefined,
    opciones: def.Opciones || [],
    multiple: def.Tipo === 'multiselect',
    isDynamic: true,
    // Los atributos dinámicos se definen sobre la entidad Material, así que son atributos del
    // material salvo los que guardan un código por relación (ver `esAtributoDeMaterial` en
    // `dynamicColumns`).
    esAtributoDeMaterial: !TIPOS_COLUMNA_POR_RELACION.includes(type),
    editable: def.Editable !== false,
    orden: def.Orden || 999,
    minWidth: anchoDeAtributo(def.Clave),
  };
}

const dynamicColumns = computed(() => {
  void materialesRaw.value;

  const providers = getFlagProviders();
  // Se suma como un provider más: la columna queda visible por el parámetro de extrusión o por la
  // configuración estándar de la categoría, lo que se cumpla primero.
  if (requiereDensidadExtrusion.value) {
    providers.push({ Densidad: true });
  }
  const labels = getCatLabels();
  let cols = [];

  if (isTintaCategory.value) {
    cols = [...TINTA_FIXED_COLS];
    if (showAnilox.value) cols.push('CodigoAnilox');
    if (showCinta.value) cols.push('CodigoCinta');
  }

  if (isBarnizCategory.value) {
    cols = [...BARNIZ_FIXED_COLS];
    if (showAnilox.value) cols.push('CodigoAnilox');
    if (showCinta.value) cols.push('CodigoCinta');
  }

  const nativeProps = DYN_ATTRS.filter((prop) => {
    if ((isTintaCategory.value || isBarnizCategory.value) && cols.includes(prop)) return false;
    return providers.some((cfg) => toOn(cfg?.[prop]));
  });

  // 3. Generar Objetos Columna para las Fijas de Tinta
  const fixedTintaCols = isTintaCategory.value
    ? cols.map((prop) => {
        const type = ATTR_TYPE[prop] || 'text';
        let label = PRETTY(prop);

        if (prop === 'CuerpoImpresor') label = 'Cuerpo Impresor';
        if (prop === 'CodigoColor') label = 'Color';
        if (prop === 'Material') label = 'Tinta'; // Label visual
        if (prop === 'LadoAplicacion') label = 'Ubicación';
        if (prop === 'CodigoTintaTipo') label = 'Tipo Tinta';
        if (prop === 'CodigoAnilox') label = 'Anilox';
        if (prop === 'CodigoCinta') label = 'Cinta Bifaz';
        if (prop === 'MatrizAdicional') label = 'Matriz Adic.';

        const numMeta = NUMBER_META[prop] || {};
        const minWidth = anchoPorTipoDeControl(type);

        return {
          prop,
          type,
          modelKey: prop,
          label,
          step: numMeta.step,
          precision: numMeta.precision,
          isDynamic: false,
          // Columnas fijas de Tinta/Barniz: describen cómo se aplica la tinta en el proceso
          // (cuerpo impresor, lado, anilox, cobertura…), no son atributos del material.
          esAtributoDeMaterial: false,
          editable: true,
          minWidth,
        };
      })
    : [];

  const fixedBarnizCols = isBarnizCategory.value
    ? cols.map((prop) => {
        const type = ATTR_TYPE[prop] || 'text';
        let label = PRETTY(prop);

        if (prop === 'CuerpoImpresor') label = 'Cuerpo Impresor';
        if (prop === 'Material') label = props.categoria?.Descripcion || 'Barniz';
        if (prop === 'LadoAplicacion') label = 'Ubicación';
        if (prop === 'CodigoAnilox') label = 'Anilox';
        if (prop === 'CodigoCinta') label = 'Cinta Bifaz';
        if (prop === 'MatrizAdicional') label = 'Matriz Adic.';

        const numMeta = NUMBER_META[prop] || {};
        const minWidth = anchoPorTipoDeControl(type);

        return {
          prop,
          type,
          modelKey: prop,
          label,
          step: numMeta.step,
          precision: numMeta.precision,
          isDynamic: false,
          // Columnas fijas de Tinta/Barniz: describen cómo se aplica la tinta en el proceso
          // (cuerpo impresor, lado, anilox, cobertura…), no son atributos del material.
          esAtributoDeMaterial: false,
          editable: true,
          minWidth,
        };
      })
    : [];

  const nativeCols = nativeProps.map((prop) => {
    const type = ATTR_TYPE[prop] || 'number';
    const modelKey = VALUE_PROP[prop] || prop;
    const labelRaw = labels?.[modelKey];
    let label =
      typeof labelRaw === 'string' && labelRaw.trim().length > 0 ? labelRaw.trim() : PRETTY(prop);

    if (['Ancho', 'Alto', 'Largo'].includes(prop)) {
      label = `${label} (${unidadVisual.value})`;
    }

    const numMeta = NUMBER_META[prop] || {};

    return {
      prop,
      type,
      modelKey,
      label,
      step: numMeta.step ?? 0.01,
      precision: numMeta.precision ?? 0,
      isDynamic: false,
      // `nativeProps` sale de `DYN_ATTRS` filtrado por la configuración de la categoría: son
      // campos propios del material (Ancho, Gramaje, Densidad, …), a diferencia de las
      // columnas fijas de Tinta/Barniz, que describen el proceso y no el material.
      esAtributoDeMaterial: !TIPOS_COLUMNA_POR_RELACION.includes(type),
      minWidth: anchoDeAtributo(prop),
    };
  });

  const allCurrentCols = [...(isTintaCategory.value ? cols : []), ...nativeProps];

  const dynamicAttrCols = atributosDinamicos.value
    .filter((def) => !allCurrentCols.includes(def.Clave))
    .map((def) => mapDynamicDefToCol(def));

  return [
    ...fixedTintaCols,
    ...fixedBarnizCols,
    ...nativeCols,
    ...dynamicAttrCols.sort((a, b) => a.orden - b.orden),
  ];
});

// === BÚSQUEDA REMOTA ===
const handleRemoteSearch = async (query, prop) => {
  loadingSearch.value[prop] = true;
  try {
    let results = [];
    if (prop === 'CodigoAnilox') {
      results = await tintaStore.searchAniloxHTTP(query);
    } else if (prop === 'CodigoCinta') {
      results = await tintaStore.searchCintaHTTP(query);
    }

    if (Array.isArray(results)) {
      if (prop === 'CodigoAnilox') aniloxOptions.value = results;
      if (prop === 'CodigoCinta') cintaOptions.value = results;
    }
  } catch (e) {
    console.error('Error buscando material remoto', e);
  } finally {
    loadingSearch.value[prop] = false;
  }
};

const getRemoteOptions = (prop) => {
  if (prop === 'CodigoAnilox') return aniloxOptions.value;
  if (prop === 'CodigoCinta') return cintaOptions.value;
  return [];
};

function onDeleteRowByRef(row) {
  const idx = localModel.value.ElementoMateriales.indexOf(row);
  if (idx !== -1) {
    localModel.value.ElementoMateriales.splice(idx, 1);
    emitChanges();
    if (!aplicaRegla.value || !selectedMaterialAnchoMM) return;
    if ((localModel.value.ElementoMateriales?.length ?? 0) === 0) {
      selectedMaterialAnchoMM.value = 0;
    } else {
      recomputeSelectedAnchoMM();
    }
  }
}

// Tinta por defecto del proceso (Configuraciones por defecto); sin configurar, la genérica.
function camposTintaOnAddRow() {
  const defecto = tintaDefectoPorProceso.value(props.proceso?.Codigo);
  if (!defecto) {
    return { Material: { ...TINTA_GENERICA }, MaterialDesc: TINTA_GENERICA.DescripcionInterna };
  }
  return camposTintaPorDefecto(defecto);
}

// Barniz por defecto del proceso (Configuraciones por defecto); sin configurar, la fila queda sin barniz.
function camposBarnizOnAddRow() {
  const defecto = barnizDefectoPorProceso.value(props.proceso?.Codigo);
  if (!defecto) return { Material: {}, MaterialDesc: '' };
  return { Material: { ...defecto }, MaterialDesc: defecto.DescripcionInterna };
}

function onAddRow() {
  if (isTintaCategory.value) {
    localModel.value.ElementoMateriales.push({
      CuerpoImpresor: null,
      CodigoTintaTipo: tipoTintaDefectoPorProceso.value(props.proceso?.Codigo),
      Cobertura: coberturaTintaPorProceso.value(props.proceso?.Codigo) ?? 50,
      ...camposTintaOnAddRow(),
      MaterialTipoConfig: {},
    });
  } else if (isBarnizCategory.value) {
    localModel.value.ElementoMateriales.push({
      CuerpoImpresor: null,
      Cobertura: coberturaBarnizPorProceso.value(props.proceso?.Codigo) ?? 100,
      ...camposBarnizOnAddRow(),
      MaterialTipoConfig: {},
    });
  } else {
    localModel.value.ElementoMateriales.push({
      Material: {},
      Porcentaje: 0,
      MaterialTipoConfig: {},
    });
  }
  emitChanges();
}

function onAddRowForTornillo(n) {
  localModel.value.ElementoMateriales.push({
    Material: {},
    Porcentaje: 0,
    NumeroTornillo: n,
    MaterialTipoConfig: {},
  });
  emitChanges();
}

const LIMITE_PAGINA_MATERIALES = 50;

// El desplegable de cada <input-material> pide sus propias páginas (búsqueda remota y scroll
// infinito viven en ese componente). Acá sólo se mantiene la primera página sin búsqueda, que
// se precarga al montar y se pasa como `precarga` (así abrir un select no vuelve a pedirla) y
// de la que además se leen las etiquetas de la categoría (`getCatLabels`).
async function fetchMateriales() {
  if (!materialesHabilitados.value) {
    materialesRaw.value = [];
    return;
  }
  const filters = {
    categoria: props.categoria.Codigo,
    page: 1,
    limit: LIMITE_PAGINA_MATERIALES,
    modulo: currentModule,
  };
  if (props.CodigoFamiliaMaterial) filters['codigoFamilia'] = props.CodigoFamiliaMaterial;
  const response = await MaterialService.findAllWithQuery(new URLSearchParams(filters).toString());
  materialesRaw.value = response?.data ?? [];
  nextTick(() => recomputeSelectedAnchoMM());
}

// Cada <input-material> avisa cuando termina de cargar una página; el ancho del material
// publicado (`selectedMaterialAnchoMM`) se recalcula igual que antes tras cada carga.
function alCargarMateriales() {
  nextTick(() => recomputeSelectedAnchoMM());
}

function fetchMaterialesMezcla() {
  MaterialService.findAll({ tipoItem: tipoItemMezcla.value, page: 0, limit: 200 }).then(
    (response) => {
      if (response?.data) materialesMezcla.value = response.data;
    },
  );
}

async function handleMaterialMezclaChange(tornilloIndex, codigo) {
  if (!codigo) return;
  const num = tornilloIndex + 1;
  if (rowsByTornillo(num).length > 0) return;
  try {
    const response = await MaterialService.findByCode(codigo);
    const mat = response?.data;
    const formulas = mat?.MaterialFormula;
    if (!formulas?.length) return;
    // Atributos físicos del componente que la grilla de resinas puede mostrar como
    // columnas dinámicas (Densidad, etc.). Se copian a nivel fila —que es lo que bindea
    // la grilla via row[col.prop]— y dentro de Material por consistencia.
    const PHYS_ATTRS = [
      'Densidad',
      'Espesor',
      'Gramaje',
      'Ancho',
      'Alto',
      'Largo',
      'Diametro',
      'Rendimiento',
    ];
    formulas.forEach((f) => {
      if (!f.CodigoMaterialFormula) return;
      const comp = f.MaterialComponente;
      const row = {
        Material: comp ? { Codigo: comp.Codigo, DescripcionInterna: comp.DescripcionInterna } : {},
        Porcentaje: f.Proporcion ?? 0,
        NumeroTornillo: num,
        MaterialTipoConfig: {},
      };
      if (comp) {
        PHYS_ATTRS.forEach((attr) => {
          if (comp[attr] !== undefined && comp[attr] !== null) {
            row[attr] = comp[attr];
            row.Material[attr] = comp[attr];
          }
        });
      }
      localModel.value.ElementoMateriales.push(row);
    });
    emitChanges();
  } catch (e) {
    console.error('Error cargando fórmula del material', e);
  }
}

const isMultiMaterialEffective = computed(() => {
  if (IsProcesoExtrusion.value) return true;
  if (props.categoria?.MultiMaterial === true) return true;
  const rels = Array.isArray(props.proceso?.ProcesoElementoTipoCategoriaMaterial)
    ? props.proceso.ProcesoElementoTipoCategoriaMaterial
    : [];

  const myCatCode = Number(props.categoria?.Codigo ?? props.categoria?.CodigoCategoria ?? 0);
  const config = rels.find((rel) => {
    const relCatCode = Number(rel.CodigoCategoriaMaterial || rel.CategoriaMaterial?.Codigo || 0);
    return relCatCode === myCatCode;
  });

  return !!config?.MultiMaterial;
});

onMounted(async () => {
  if (
    tintaStore &&
    tintaStore.firstTipoTinta &&
    (!tipoTintaList.value || tipoTintaList.value.length === 0)
  ) {
    await tintaStore.firstTipoTinta();
  }
  await loadAtributosDinamicos();
  fetchMateriales(props.proceso);
  if (IsProcesoExtrusion.value) fetchMaterialesMezcla();

  if (localModel.value.ElementoMateriales) {
    localModel.value.ElementoMateriales.forEach((row) => deserializeAtributosDinamicos(row));
  }
  // Pre-cargar opciones de Anilox/Cinta si ya existen valores
  const savedAnilox = localModel.value.ElementoMateriales?.filter((r) => r.CodigoAnilox) || [];
  const savedCinta = localModel.value.ElementoMateriales?.filter((r) => r.CodigoCinta) || [];
  if (savedAnilox.length > 0) handleRemoteSearch('', 'CodigoAnilox');
  if (savedCinta.length > 0) handleRemoteSearch('', 'CodigoCinta');

  nextTick(() => recomputeSelectedAnchoMM());
});

// Recargar atributos dinámicos y la lista de materiales cuando cambia la categoría
watch(
  () => props.categoria?.Codigo,
  async () => {
    await loadAtributosDinamicos();
    fetchMateriales(props.proceso);
    if (localModel.value.ElementoMateriales) {
      localModel.value.ElementoMateriales.forEach((row) => deserializeAtributosDinamicos(row));
    }
    fetchMateriales(props.proceso);
  },
  { deep: true },
);

watch(
  () => [
    currentElemento.value?.AnchoMinimoHojaCalculado,
    currentElemento.value?.LargoMinimoHojaCalculado,
  ],
  ([newAncho, newLargo], [oldAncho, oldLargo]) => {
    if (!localModel.value?.ElementoMateriales) return;

    const relacion =
      props.proceso?.ProcesoElementoTipoCategoriaMaterial?.find(
        (r) => r.CodigoCategoriaMaterial === props.categoria?.Codigo,
      ) ||
      props.proceso?.Proceso?.ProcesoElementoTipoCategoriaMaterial?.find(
        (r) => r.CodigoCategoriaMaterial === props.categoria?.Codigo,
      );

    const flagAuto = props.categoria?.DimensionesAutomaticas ?? relacion?.DimensionesAutomaticas;
    const isAuto = flagAuto === true || flagAuto === 1 || String(flagAuto).toLowerCase() === 'true';

    if (!isAuto) return;

    let huboCambios = false;

    localModel.value.ElementoMateriales.forEach((row) => {
      const materialRef = row.Material;
      if (!materialRef) return;

      const isExact =
        materialRef.Exact === true ||
        materialRef.Exact === 1 ||
        String(materialRef.Exact).toLowerCase() === 'true';

      // LOGICA PARA CAJA
      if (currentElementoBase === ElementoBase.CAJA) {
        if (isExact) {
          if (newAncho !== undefined && newAncho !== oldAncho) {
            const currentAncho = Number(row.Ancho || 0);
            if (currentAncho === 0 || currentAncho < newAncho || currentAncho === oldAncho) {
              row.Ancho = newAncho;
              huboCambios = true;
            }
          }
          if (newLargo !== undefined && newLargo !== oldLargo) {
            const currentLargo = Number(row.Largo || 0);
            if (currentLargo === 0 || currentLargo < newLargo || currentLargo === oldLargo) {
              row.Largo = newLargo;
              huboCambios = true;
            }
          }
        }
      }

      //LOGICA PARA FLEXIBLE
      else if (currentElementoBase === ElementoBase.FLEXIBLE) {
        const masterWidth = Number(materialRef.Ancho || 0);
        if (isExact || masterWidth <= 0) {
          if (newAncho !== undefined && newAncho !== oldAncho) {
            const currentAncho = Number(row.Ancho || 0);

            if (currentAncho === 0 || currentAncho < newAncho || currentAncho === oldAncho) {
              row.Ancho = newAncho;
              huboCambios = true;
            }
          }
        }
      }

      // LOGICA PARA ETIQUETA
      else if (currentElementoBase === ElementoBase.ETIQUETA) {
        if (newAncho !== undefined && newAncho !== oldAncho) {
          const anchoOptimizadoNuevo = calcularAnchoOptimizado(materialRef, newAncho);
          const anchoOptimizadoViejo = calcularAnchoOptimizado(materialRef, oldAncho || 0);

          const currentAncho = Number(row.Ancho || 0);

          if (
            currentAncho === 0 ||
            currentAncho < anchoOptimizadoNuevo ||
            currentAncho === anchoOptimizadoViejo
          ) {
            row.Ancho = anchoOptimizadoNuevo;
            huboCambios = true;
          }
        }
      }
    });

    if (huboCambios) {
      emitChanges();
    }
  },
  { immediate: false, deep: true },
);

const handleDblClickAncho = (row) => {
  if (!canEditAncho(row)) return;

  const minMM = Number(anchoMinimoMMInjected?.value || 0);
  if (minMM <= 0) return;

  const material = row.Material || {};
  const isExact =
    material.Exact === true ||
    material.Exact === 1 ||
    String(material.Exact).toLowerCase() === 'true';
  const materialAnchoMasterMM = Number(material.Ancho || 0);

  let nuevoAnchoMM = 0;

  if (isExact) {
    nuevoAnchoMM = minMM;
  } else {
    if (currentElementoBase === ElementoBase.FLEXIBLE) {
      if (materialAnchoMasterMM <= 0) {
        nuevoAnchoMM = minMM;
      } else {
        return;
      }
    } else if (currentElementoBase === ElementoBase.ETIQUETA) {
      if (materialAnchoMasterMM <= 0) {
        nuevoAnchoMM = minMM;
      } else {
        const divisiones = Math.floor(materialAnchoMasterMM / minMM);
        nuevoAnchoMM =
          divisiones === 0 ? materialAnchoMasterMM : materialAnchoMasterMM / divisiones;
      }
    }
  }

  if (nuevoAnchoMM > 0) {
    row.Ancho = nuevoAnchoMM;
    if (selectedMaterialAnchoMM) {
      selectedMaterialAnchoMM.value = nuevoAnchoMM;
    }
    emitChanges();
  }
};

function onUserChangeAncho(row, val) {
  if (!aplicaRegla.value || !selectedMaterialAnchoMM) return;
  const anchoFijo = Number(row?.Material?.Ancho);
  if (anchoFijo > 0) return;
  selectedMaterialAnchoMM.value = Number(val) || 0;
}

const calcularAnchoOptimizado = (material, anchoMinimo) => {
  const isExact =
    material.Exact === true ||
    material.Exact === 1 ||
    String(material.Exact).toLowerCase() === 'true';
  const masterWidth = Number(material.Ancho || 0);

  if (isExact || masterWidth <= 0) {
    return anchoMinimo;
  }

  const divisiones = Math.floor(masterWidth / anchoMinimo);
  return divisiones > 0 ? masterWidth / divisiones : masterWidth;
};

// Costo y Cantidad son valores propios del ítem que pisan el cálculo: sólo se copian del material
// si el bitfield de la categoría habilita la columna para el módulo actual. Si la columna está
// oculta, el usuario no puede verlos ni editarlos, así que el ítem no debe congelarlos (el Costo
// del material está en su moneda nativa y pisaría al costo ya convertido a USD).
const ATTRS_COPIADOS_SI_VISIBLES = ['CostoMaterial', 'CantidadMaterial'];

function esAtributoVisible(attr, selectedMaterial) {
  const categorias = [props?.categoria, selectedMaterial?.MaterialTipo?.MaterialCategoria];
  return categorias.some((cfg) => toOn(cfg?.[attr]));
}

const ATTRS_PROPIOS_DEL_ITEM = [
  'CuerpoImpresor',
  'Color',
  'CodigoColor',
  'LadoAplicacion',
  'MatrizAdicional',
  'Kilos',
  'CodigoAnilox',
  'CodigoCinta',
  'CodigoTintaTipo',
  'Material',
  ...ATTRS_COPIADOS_SI_VISIBLES,
];

function copyMaterialAttributes(selectedMaterial, row) {
  if (!selectedMaterial) {
    return;
  }

  DYN_ATTRS.forEach((attr) => {
    if (ATTRS_COPIADOS_SI_VISIBLES.includes(attr) && !esAtributoVisible(attr, selectedMaterial)) {
      return;
    }
    const key = VALUE_PROP[attr] || attr;
    const val = selectedMaterial[key] ?? selectedMaterial[attr];
    if (val !== undefined && val !== null) {
      row[key] = val;
    } else if (!ATTRS_PROPIOS_DEL_ITEM.includes(attr)) {
      row[key] = null;
    }
  });
  atributosDinamicos.value.forEach((def) => {
    let val = null;
    if (
      selectedMaterial.AtributosAdicionales &&
      typeof selectedMaterial.AtributosAdicionales === 'object'
    ) {
      val = selectedMaterial.AtributosAdicionales[def.Clave];
    }
    if (val === undefined || val === null) val = selectedMaterial[def.Clave];
    row[def.Clave] = val ?? null;
  });

  const relacion =
    props.proceso?.ProcesoElementoTipoCategoriaMaterial?.find(
      (r) => r.CodigoCategoriaMaterial === props.categoria?.Codigo,
    ) ||
    props.proceso?.Proceso?.ProcesoElementoTipoCategoriaMaterial?.find(
      (r) => r.CodigoCategoriaMaterial === props.categoria?.Codigo,
    );

  const flagAuto = props.categoria?.DimensionesAutomaticas ?? relacion?.DimensionesAutomaticas;
  const isAuto = flagAuto === true || flagAuto === 1 || String(flagAuto).toLowerCase() === 'true';
  const isExact =
    selectedMaterial.Exact === true ||
    selectedMaterial.Exact === 1 ||
    String(selectedMaterial.Exact).toLowerCase() === 'true';

  if (isAuto && currentElemento.value) {
    const anchoMinCalculado =
      currentElemento.value.AnchoMinimoHojaCalculado || anchoMinimoMMInjected?.value || 0;
    const largoMinCalculado = currentElemento.value.LargoMinimoHojaCalculado || 0;

    if (currentElementoBase === ElementoBase.CAJA) {
      if (isExact) {
        row.Ancho = anchoMinCalculado;
        row.Largo = largoMinCalculado;
      }
    } else if (currentElementoBase === ElementoBase.FLEXIBLE) {
      const masterWidth = Number(selectedMaterial.Ancho || 0);

      if (isExact || masterWidth <= 0) {
        row.Ancho = anchoMinCalculado;
      }
    } else if (currentElementoBase === ElementoBase.ETIQUETA) {
      row.Ancho = calcularAnchoOptimizado(selectedMaterial, anchoMinCalculado);
    }
  } else {
    if (selectedMaterial.Ancho == null) row.Ancho = null;
  }

  if (aplicaRegla.value && selectedMaterialAnchoMM) {
    const fijo = Number(selectedMaterial.Ancho);
    selectedMaterialAnchoMM.value = Number.isFinite(fijo) ? fijo : Number(row.Ancho || 0) || 0;
  }

  emitChanges();
}

// COTI-635: va al final del setup porque es `immediate` y `convertirRealesAUnidadActiva` llama a
// `emitChanges`, que usa `emits` (declarado más arriba con `const`): registrado antes de esa
// línea rompe con "Cannot access 'emits' before initialization".
watch(
  () => {
    if (!esOrdenProduccion.value) return null;
    const firmaUnidades = (localModel.value?.ElementoMateriales || [])
      .map((teorico) => unidadActiva(teorico, props.unidadRecurso).codigo)
      .join(',');
    return `${props.unidadRecurso?.Codigo ?? ''}|${firmaUnidades}`;
  },
  convertirRealesAUnidadActiva,
  { immediate: true },
);

// Eventos nativos
onBeforeMount(async () => {
  await firstConfiguraciones();
});
</script>

<style scoped>
.input-materiales-wrapper {
  overflow-x: auto;
}
.button-position {
  display: flex;
  justify-content: flex-end;
}
.ancho_total {
  width: 100%;
}

/* COTI-635 (8.11): valor copiado del teórico mostrado en la fila real, de sólo lectura. */
.valor-solo-lectura {
  color: #909399;
}
.color-solo-lectura-swatch {
  display: inline-block;
  width: 14px;
  height: 14px;
  margin-right: 4px;
  vertical-align: middle;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
}

.error-porcentaje :deep(.el-input__wrapper) {
  border-color: #f56c6c !important;
  box-shadow: 0 0 0 1px #f56c6c inset !important;
}
.error-porcentaje :deep(.el-input__inner) {
  border-color: #f56c6c !important;
}
.error-porcentaje :deep(.el-input-number__decrease),
.error-porcentaje :deep(.el-input-number__increase) {
  border-color: #f56c6c !important;
}
.error-message {
  background-color: #fef0f0;
  border: 1px solid #fbc4c4;
  border-radius: 4px;
  padding: 8px 12px;
}

/* COTI-642 (49677): fila cuyo material no coincide con el material resultante de su proceso
   origen — fondo rojo bien visible. Vuelve al color normal al elegir un proceso permitido. */
:deep(.fila-material-origen-invalido td.el-table__cell) {
  background-color: #fab6b6 !important;
}
:deep(.num-col .cell) {
  padding: 0 8px;
}
:deep(.num-col .el-input-number) {
  width: 100%;
}
:deep(.num-col .el-input__wrapper) {
  width: 100%;
}

/* ===== Estilos por tornillo (extrusión) ===== */
.tornillo-section {
  margin-bottom: 16px;
}
.tornillo-section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 6px;
  color: #303133;
  cursor: pointer;
  user-select: none;
}
.tornillo-section-chevron {
  font-size: 11px;
  flex-shrink: 0;
  transition: transform 0.2s;
  color: #606266;
}
.tornillo-section-chevron.is-collapsed {
  transform: rotate(-90deg);
}
.tornillo-section-title {
  white-space: nowrap;
  flex-shrink: 0;
}
.tornillo-material-select {
  flex: 1;
  max-width: 320px;
}
.tornillo-sum-badge {
  padding: 2px 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
}
.tornillo-sum-ok {
  background-color: #f0f9eb;
  color: #67c23a;
  border: 1px solid #c2e7b0;
}
.tornillo-sum-error {
  background-color: #fef0f0;
  color: #f56c6c;
  border: 1px solid #fbc4c4;
}

/* COTI-635: el contenido de la primera columna quedaba un renglón más abajo que el del resto.
   `.el-table .cell` es un bloque con `line-height: 23px`, y Element Plus le antepone sus
   marcadores de árbol —`el-table__expand-icon` en el teórico, `el-table__indent` y
   `el-table__placeholder` en la fila real—, que son INLINE. Al ser el selector (`input-material`)
   un `div`, esos marcadores ocupaban la primera línea y el selector caía a la segunda. Con la
   celda en flex los tres comparten una sola línea, centrada verticalmente como el resto de
   las columnas. */
:deep(.col-material .cell) {
  display: flex;
  align-items: center;
}

/* COTI-635 (8.13): sufijo con la abreviatura de la unidad en la que se carga la cantidad
   real, al lado del input en vez de en un renglón aparte, para no ensanchar la celda. */
.cantidad-real-input {
  display: flex;
  align-items: center;
  /* El input ya no ocupa el 100 % de la celda, así que el conjunto input + abreviatura se
     centra para acompañar el `align="center"` de la columna. */
  justify-content: center;
  gap: 4px;
}
.aviso-otra-unidad {
  color: #e6a23c;
  vertical-align: middle;
}
.unidad-sufijo {
  color: #909399;
  font-size: 12px;
  white-space: nowrap;
}
</style>
